// NSE ISIN -> real trading symbol master.
// Source: https://nsearchives.nseindia.com/content/equities/EQUITY_L.csv
// Downloaded 15-Jul-2026. Used to resolve a holding's real NEAT trading
// symbol from its ISIN, since Sharepro's NSDL holdings feed only gives us
// a company name + ISIN, never a trading symbol -- this was the root cause
// of holdings square-off files being rejected by NEAT (company name written
// into the symbol column instead of a real scrip code, e.g. "YES BANK L"
// instead of "YESBANK").
//
// 2385 equities, zero ISIN collisions. Re-download and regenerate
// this file periodically (new listings, symbol changes) -- it will silently
// fall back to the old (broken) behavior for any ISIN not found here, so a
// stale map degrades gracefully rather than crashing, but should still be
// refreshed every few months.
export default {
  'IN9175A01010': 'JISLDVREQS',
  'IN9623B01058': 'FELDVR',
  'INE001B01026': 'KRBL',
  'INE001E01012': 'PREMCO',
  'INE002A01018': 'RELIANCE',
  'INE002L01015': 'SJVN',
  'INE002S01010': 'MGL',
  'INE003A01024': 'SIEMENS',
  'INE004A01022': 'PROTEAN',
  'INE005B01027': 'AVANTEL',
  'INE005I01014': 'AMDIND',
  'INE006I01046': 'ASTRAL',
  'INE006Z01016': 'ARVEE',
  'INE007A01025': 'CRISIL',
  'INE007B01023': 'GEOJITFSL',
  'INE007N01010': 'FEDFINA',
  'INE008A01015': 'IDBI',
  'INE009A01021': 'INFY',
  'INE00CA01015': 'TREJHARA',
  'INE00CE01017': 'SVLL',
  'INE00E101023': 'BIKAJI',
  'INE00EM01016': 'MEGASTAR',
  'INE00EV01017': 'HARIOMPIPE',
  'INE00F201020': 'PRUDENT',
  'INE00FF01025': 'ACUTAAS',
  'INE00H001014': 'SWIGGY',
  'INE00HZ01011': 'BNAGROCHEM',
  'INE00IK01029': 'OSWALSEEDS',
  'INE00IN01015': 'STOVEKRAFT',
  'INE00KV01022': 'RAJMET',
  'INE00LM01029': 'SONAMLTD',
  'INE00LO01017': 'CRAFTSMAN',
  'INE00M201021': 'SWSOLAR',
  'INE00M901018': 'INTERARCH',
  'INE00OQ01016': 'DHARMAJ',
  'INE00PV01013': 'AHLADA',
  'INE00Q601028': 'STUDDS',
  'INE00QT01015': 'SGIL',
  'INE00R701025': 'DALBHARAT',
  'INE00RL01028': 'HILINFRA',
  'INE00S901012': 'NILASPACES',
  'INE00SW01015': 'BCPL',
  'INE00U401027': 'UNIECOM',
  'INE00VM01036': 'MANORAMA',
  'INE00WC01027': 'AFFLE',
  'INE00WV01027': 'CMRGREEN',
  'INE00XB01019': 'SEDEMAC',
  'INE00Y201027': 'FLAIR',
  'INE00Y801016': 'AKG',
  'INE00YB01025': 'ABINFRA',
  'INE00YJ01010': 'JARO',
  'INE00Z501029': 'KRITIKA',
  'INE00ZE01026': 'AFSL',
  'INE010601016': 'ENTERO',
  'INE010A01011': 'PRSMJOHNSN',
  'INE010B01027': 'ZYDUSLIFE',
  'INE010J01012': 'TEJASNET',
  'INE010V01017': 'LTTS',
  'INE011E01029': 'BALUFORGE',
  'INE011K01018': 'TEGA',
  'INE012A01025': 'ACC',
  'INE012Q01039': 'RNBDENIMS',
  'INE013801027': 'KSHITIJPOL',
  'INE013P01021': 'ONESOURCE',
  'INE014B01011': 'TECILCHEM',
  'INE015C01016': 'TINNARUBR',
  'INE015D01022': 'MANAKSIA',
  'INE016A01026': 'DABUR',
  'INE016M01021': 'DNAMEDIA',
  'INE016Q01014': 'CEINSYS',
  'INE017A01032': 'GESHIP',
  'INE017W01010': 'SMLT',
  'INE018401013': 'SUVIDHAA',
  'INE018A01030': 'LT',
  'INE018E01016': 'SBICARD',
  'INE019A01038': 'JSWSTEEL',
  'INE019C01026': 'HSCL',
  'INE019J01013': 'HEALTHX',
  'INE01A001028': 'STANLEY',
  'INE01BK01022': 'AWHCL',
  'INE01C001026': 'AARTECH',
  'INE01EA01019': 'VMM',
  'INE01EE01011': 'BBTCL',
  'INE01EG01016': 'RITCO',
  'INE01EO01010': 'SPECTRUM',
  'INE01FR01028': 'STYLEBAAZA',
  'INE01GN01025': 'IRISDOREME',
  'INE01II01013': 'SILGO',
  'INE01IU01018': 'SKYGOLD',
  'INE01JE01028': 'MARINE',
  'INE01KI01027': 'VINNY',
  'INE01NE01012': 'SRD',
  'INE01P501012': 'XELPMOC',
  'INE01QM01018': 'EMUDHRA',
  'INE01R501028': 'VIKRAN',
  'INE01TY01017': 'CANHLIFE',
  'INE020801028': 'SPENCERS',
  'INE020B01018': 'RECLTD',
  'INE020D01022': 'BAIDFIN',
  'INE020G01017': 'INSPIRISYS',
  'INE020J01029': 'GOKUL',
  'INE021A01026': 'ASIANPAINT',
  'INE021O01019': 'DODLA',
  'INE022C01012': 'EUROTEXIND',
  'INE022I01019': 'ASIANTILES',
  'INE022Q01020': 'IEX',
  'INE023A01030': 'NSIL',
  'INE023H01027': 'NECLIFE',
  'INE023M01027': 'SETUINFRA',
  'INE024001021': 'AEROFLEX',
  'INE024D01016': 'PRUDMOULI',
  'INE024F01011': 'SHILCTECH',
  'INE024L01027': 'GRAVITA',
  'INE025A01027': 'CONSOFINVT',
  'INE025B01025': 'GOLDIAM',
  'INE025R01021': 'ARTEMISMED',
  'INE026A01025': 'GSFC',
  'INE027A01015': 'RCF',
  'INE027H01010': 'MAXHEALTH',
  'INE027T01023': 'RUDRA',
  'INE028A01039': 'BANKBARODA',
  'INE029A01011': 'BPCL',
  'INE029L01018': 'KICL',
  'INE02A801020': 'ROSSARI',
  'INE02AR01019': 'ANMOL',
  'INE02EZ01022': 'AXITA',
  'INE02H701025': 'NOVAAGRI',
  'INE02ID01020': 'RAYMONDLSL',
  'INE02IJ01035': 'AZAD',
  'INE02L001032': 'BOROSCI',
  'INE02NC01014': 'FINOPB',
  'INE02PY01013': 'BOROLTD',
  'INE02RE01045': 'FIRSTCRY',
  'INE02WG01024': 'WEL',
  'INE02YR01019': 'EMIL',
  'INE02ZQ01018': 'CORONA',
  'INE030A01027': 'HINDUNILVR',
  'INE031A01017': 'HUDCO',
  'INE031B01049': 'AJANTPHARM',
  'INE032A01023': 'BOMDYEING',
  'INE032B01021': 'PRIMESECU',
  'INE032Z01020': 'BSHSL',
  'INE034A01011': 'ARVIND',
  'INE034D01049': 'PTL',
  'INE034S01021': 'ARVSMART',
  'INE035801013': 'AERONEU',
  'INE035D01020': 'SOTL',
  'INE036B01030': 'GAEL',
  'INE036D01028': 'KARURVYSYA',
  'INE037A01022': 'UNIENTER',
  'INE037B01020': 'SHARDUL',
  'INE037Z01029': 'CEWATER',
  'INE038A01020': 'HINDALCO',
  'INE038F01029': 'TVTODAY',
  'INE039A01010': 'IFCI',
  'INE039B01026': 'CINEVISTA',
  'INE039C01032': 'JAMNAAUTO',
  'INE039O01029': 'JASH',
  'INE03CC01015': 'JUBLCPL',
  'INE03DD01011': 'RETAIL',
  'INE03EI01018': 'MAXESTATES',
  'INE03HW01020': 'VLEGOV',
  'INE03JI01017': 'DGCONTENT',
  'INE03JT01014': 'GODIGIT',
  'INE03NU01014': 'BRIGHOTEL',
  'INE03Q201024': 'ALIVUS',
  'INE03QK01018': 'COHANCE',
  'INE03RS01027': 'DRCSYSTEMS',
  'INE03V001013': 'UNIVPHOTO',
  'INE03YM01018': 'CHEMCON',
  'INE040A01034': 'HDFCBANK',
  'INE040D01038': 'MAYURUNIQ',
  'INE040H01021': 'SUZLON',
  'INE040M01013': 'TREEHOUSE',
  'INE041A01016': 'DHAMPURSUG',
  'INE042A01014': 'ESCORTS',
  'INE043A01012': 'GTL',
  'INE043C01018': 'IVP',
  'INE043W01024': 'VIJAYA',
  'INE044A01036': 'SUNPHARMA',
  'INE045601023': 'PARAS',
  'INE045A01017': 'ADOR',
  'INE045B01015': 'NELCO',
  'INE045J01034': 'FCL',
  'INE046A01015': 'RIIL',
  'INE046W01019': 'MUTHOOTMF',
  'INE047A01021': 'GRASIM',
  'INE047B01011': 'GILLANDERS',
  'INE047O01014': 'NIBL',
  'INE048B01035': 'JAGSNPHARM',
  'INE048C01025': 'VHLTD',
  'INE048G01026': 'NAVINFLUOR',
  'INE049A01027': 'HIMATSEIDE',
  'INE049B01025': 'WOCKPHARMA',
  'INE049I01012': 'NAHARCAP',
  'INE04AK01028': 'SBC',
  'INE04I401011': 'KPITTECH',
  'INE04LG01015': 'PAR',
  'INE04TZ01018': 'ETHOSLTD',
  'INE04VU01023': 'STYL',
  'INE050001010': 'PPL',
  'INE050401020': 'ELIN',
  'INE050A01025': 'BBTC',
  'INE050B01023': 'IVC',
  'INE050E01027': 'BALAMINES',
  'INE050H01012': 'RML',
  'INE050M01012': 'VSSL',
  'INE051B01021': 'VAKRANGEE',
  'INE052A01021': 'WINDMACHIN',
  'INE052I01032': 'CAMLINFINE',
  'INE052T01021': 'BESTAGRO',
  'INE053A01029': 'INDHOTEL',
  'INE053F01010': 'IRFC',
  'INE054301028': 'ODIGMA',
  'INE054A01027': 'VIPIND',
  'INE055A01016': 'ABREL',
  'INE055C01020': 'KEEPLEARN',
  'INE055S01018': 'CYIENTDLM',
  'INE056801025': 'IVALUE',
  'INE056I01025': 'REFEX',
  'INE058A01010': 'SANOFI',
  'INE058B01018': 'ZENITHEXPO',
  'INE059A01026': 'CIPLA',
  'INE059B01024': 'SIMPLEXINF',
  'INE059D01020': 'LAOPALA',
  'INE05AN01011': 'HINDWAREAP',
  'INE05CZ01011': 'RATNAVEER',
  'INE05HV01027': 'CMPDI',
  'INE05J901018': 'IGCL',
  'INE05ST01028': 'SBGLP',
  'INE05TO01019': 'AMIRCHAND',
  'INE05X901010': 'HPIL',
  'INE05XR01022': 'BHARATCOAL',
  'INE060901027': 'LIKHITHA',
  'INE060A01024': 'NAVNETEDUL',
  'INE060B01014': 'KHANDSE',
  'INE060J01017': 'FLEXITUFF',
  'INE060X01034': 'DEVIT',
  'INE061A01014': 'INDIANCARD',
  'INE061F01013': 'FORTIS',
  'INE062A01020': 'SBIN',
  'INE062D01024': 'ALICON',
  'INE063E01053': 'POCL',
  'INE063P01018': 'EQUITASBNK',
  'INE064A01026': 'TIMEX',
  'INE064C01022': 'TRIDENT',
  'INE065D01027': 'AEROENTER',
  'INE065J01024': 'TPHQ',
  'INE065X01017': 'INDGN',
  'INE066A01021': 'EICHERMOT',
  'INE066F01020': 'HAL',
  'INE066O01014': 'WONDERLA',
  'INE066P01011': 'INOXWIND',
  'INE067A01029': 'CGPOWER',
  'INE068L01024': 'CANTABIL',
  'INE068V01023': 'GLAND',
  'INE069I01010': 'EMBDL',
  'INE06HJ01020': 'ECOSMOBLTY',
  'INE06IR01021': 'OSIAHYPER',
  'INE06ST01018': 'INDIQUBE',
  'INE06WU01026': 'LAXMIINDIA',
  'INE06XZ01023': 'GEMAROMA',
  'INE06ZD01017': 'SHANTIGOLD',
  'INE070A01015': 'SHREECEM',
  'INE070C01037': 'COMPINFO',
  'INE070D01027': 'JAICORPLTD',
  'INE070I01018': 'INSECTICID',
  'INE071A01013': 'BILVYAPAR',
  'INE071D01033': 'MENONBE',
  'INE071E01023': 'UGARSUGAR',
  'INE071F01012': 'APCL',
  'INE071N01016': 'EPIGRAL',
  'INE073D01013': 'SUNDRMBRAK',
  'INE073G01016': 'ASALCBR',
  'INE073K01018': 'SONACOMS',
  'INE073V01015': 'COMSYN',
  'INE074A01025': 'PRAJIND',
  'INE074B01023': 'PARACABLES',
  'INE075A01022': 'WIPRO',
  'INE075B01020': 'SICALLOG',
  'INE075D01018': 'GMBREW',
  'INE075I01017': 'HCG',
  'INE076B01028': 'SIYSIL',
  'INE076C01018': 'IFBAGRO',
  'INE077F01035': 'GOCLCORP',
  'INE077P01034': 'THACKER',
  'INE078V01014': 'VIKRAMSOLR',
  'INE079A01024': 'AMBUJACEM',
  'INE079J01017': 'GATEWAY',
  'INE07K301024': 'ZAGGLE',
  'INE07O001026': 'EASEMYTRIP',
  'INE07OG01012': 'NDRAUTO',
  'INE07RO01027': 'SUPRIYA',
  'INE07S101038': 'PAVNAIND',
  'INE07T201019': 'RBA',
  'INE07U701015': 'IRMENERGY',
  'INE07Y701011': 'POWERINDIA',
  'INE080A01014': 'WEIZMANIND',
  'INE080B01012': 'KOHINOOR',
  'INE080I01025': 'LLOYDSENT',
  'INE081A01020': 'TATASTEEL',
  'INE081G01019': 'KANCHI',
  'INE082A01010': 'KOPRAN',
  'INE082W01014': 'WEWIN',
  'INE083A01026': 'MOREPENLAB',
  'INE083B01024': 'THEMISMED',
  'INE083C01022': 'PLASTIBLEN',
  'INE083D01012': 'BALPHARMA',
  'INE083K01017': 'BENGALASM',
  'INE084A01016': 'BANKINDIA',
  'INE084K01015': 'AMANTA',
  'INE084Q01012': 'RACE',
  'INE085001019': 'WEWORK',
  'INE085A01013': 'CHAMBLFERT',
  'INE085D01033': 'METROGLOBL',
  'INE085J01014': 'THANGAMAYL',
  'INE086A01029': 'ELECTCAST',
  'INE087A01019': 'KESORAMIND',
  'INE087B01017': 'ANIKINDS',
  'INE087H01022': 'RENUKA',
  'INE087Z01024': 'AAKASH',
  'INE088F01024': 'PARADEEP',
  'INE089A01031': 'DRREDDY',
  'INE089C01029': 'STLTECH',
  'INE08KJ01020': 'MUFIN',
  'INE08KP01019': 'DCMNVL',
  'INE08LI01020': 'KRSNAA',
  'INE08N601015': 'MBEL',
  'INE08NE01025': 'SANSTAR',
  'INE08PH01015': 'ABCOTS',
  'INE08U801020': 'SAMHI',
  'INE08ZM01014': 'GREENPANEL',
  'INE090501011': 'SCODATUBES',
  'INE090A01021': 'ICICIBANK',
  'INE090B01011': 'OMAXAUTO',
  'INE091G01026': 'JAIBALAJI',
  'INE092A01019': 'TATACHEM',
  'INE092B01025': 'INDNIPPON',
  'INE092T01019': 'IDFCFIRSTB',
  'INE093A01041': 'HEXT',
  'INE093I01010': 'OBEROIRLTY',
  'INE093R01011': 'LLOYDSENGG',
  'INE094A01015': 'HINDPETRO',
  'INE094B01013': 'ASHIKA',
  'INE094I01018': 'KOLTEPATIL',
  'INE094J01016': 'UTIAMC',
  'INE095A01012': 'INDUSINDBK',
  'INE095I01015': 'PPAP',
  'INE095N01031': 'NBCC',
  'INE096B01018': 'NUCLEUS',
  'INE098201036': 'VCL',
  'INE098F01031': 'AMRUTANJAN',
  'INE099F01013': 'SREEL',
  'INE099G01011': 'SCANSTL',
  'INE099Z01011': 'MIDHANI',
  'INE09E501017': 'RVHL',
  'INE09EO01013': 'AARTISURF',
  'INE09KD01013': 'ATAM',
  'INE09N301011': 'FLUOROCHEM',
  'INE09VQ01012': 'INDIGOPNTS',
  'INE09XN01023': 'AKUMS',
  'INE0A0S01028': 'SIGMA',
  'INE0A1101019': 'DCI',
  'INE0ADB01012': 'INNOVISION',
  'INE0AE001013': 'VPRPL',
  'INE0AG901020': 'CEIGALL',
  'INE0AJG01018': 'HEMIPROP',
  'INE0ALI01010': 'ADVAIT',
  'INE0ALR01029': 'ATALREAL',
  'INE0APB01032': 'MGEL',
  'INE0AQ201015': 'THELEELA',
  'INE0ATZ01017': 'KRONOX',
  'INE0B1K01014': 'DJML',
  'INE0B9A01018': 'BONLON',
  'INE0B9K01025': 'BANSALWIRE',
  'INE0BJS01011': 'GOCOLORS',
  'INE0BS701011': 'PREMIERENE',
  'INE0BTI01037': 'KAMOPAINTS',
  'INE0BTM01013': 'SECMARK',
  'INE0BV301023': 'MAPMYINDIA',
  'INE0BWX01014': 'AETHER',
  'INE0BX301013': 'PROSTARM',
  'INE0BY001018': 'JUBLINGREA',
  'INE0BYP01024': 'OSWALPUMPS',
  'INE0CAZ01013': 'URBANCO',
  'INE0CG401037': 'MUKKA',
  'INE0CG601016': 'MAXIND',
  'INE0CHO01012': 'ADL',
  'INE0CJD01029': 'KMEW',
  'INE0CJF01024': 'WCIL',
  'INE0CLI01024': 'RATEGAIN',
  'INE0CT101020': 'MOL',
  'INE0CU601026': 'GMRP&UI',
  'INE0CZ201020': 'ANTHEM',
  'INE0D0K01022': 'SIGACHI',
  'INE0D0U01013': 'AAATECH',
  'INE0D6701023': 'IPL',
  'INE0D6I01023': 'KSOLVES',
  'INE0DAB01012': 'RVTH',
  'INE0DD101019': 'RAILTEL',
  'INE0DK501011': 'PPLPHARMA',
  'INE0DNW01011': 'FAIRCHEMOR',
  'INE0DSF01015': 'NURECA',
  'INE0DUT01020': 'INNOVACAP',
  'INE0DYJ01015': 'SYRMA',
  'INE0E7301029': 'WAKEFIT',
  'INE0ECP01024': 'HMAAGRO',
  'INE0EEJ01023': 'BTML',
  'INE0EK901012': 'TARC',
  'INE0FFK01017': 'NPST',
  'INE0FHS01024': 'DEEPINDS',
  'INE0FMW01018': 'QMSMEDI',
  'INE0FRK01020': 'MOTISONS',
  'INE0FS801015': 'MSUMI',
  'INE0FW001016': 'MARKOLINES',
  'INE0G1L01025': 'LEMERITE',
  'INE0G5901015': 'EPACK',
  'INE0GFE01026': 'EXXARO',
  'INE0GGO01015': 'KRISHIVAL',
  'INE0GIU01018': 'UMAEXPORTS',
  'INE0GK401011': 'TATVA',
  'INE0GSL01024': 'HPAL',
  'INE0GV601021': 'ALLTIME',
  'INE0H5O01029': 'WINDLAS',
  'INE0H9F01037': 'SAIPARENT',
  'INE0H9P01028': 'ARIS',
  'INE0HF201011': 'FABTECH',
  'INE0HLU01028': 'MOBIKWIK',
  'INE0HMF01019': 'TRACXN',
  'INE0HOQ01053': 'GROWW',
  'INE0HR601026': 'DDEVPLSTIK',
  'INE0HV901016': 'IXIGO',
  'INE0I0M01023': 'PRABHA',
  'INE0I0T01010': 'VOEPL',
  'INE0I3401014': 'DBOL',
  'INE0I7C01011': 'LATENTVIEW',
  'INE0ILV01024': 'CAPILLARY',
  'INE0INJ01017': 'PLAZACABLE',
  'INE0INX01018': 'AEGISVOPAK',
  'INE0IQ001011': 'VERANDA',
  'INE0IX101010': 'DATAPATTNS',
  'INE0J0B01017': 'KOTYARK',
  'INE0J1F01024': 'RPTECH',
  'INE0J1Y01017': 'LICI',
  'INE0J5401028': 'HONASA',
  'INE0J5601015': 'KRISHNADEF',
  'INE0J5801029': 'JSLL',
  'INE0JA001018': 'VENUSPIPES',
  'INE0JM501013': 'NRL',
  'INE0JO301016': 'YATHARTH',
  'INE0JPD01013': 'SANATHAN',
  'INE0JR601024': 'YATRA',
  'INE0JS101016': 'DREAMFOLKS',
  'INE0JSX01015': 'GSLSU',
  'INE0JUI01012': 'HEXAGON',
  'INE0JUS01029': 'HARSHA',
  'INE0JVO01026': 'GARUDA',
  'INE0JWS01017': 'VALIANTLAB',
  'INE0JYY01029': 'MWL',
  'INE0KBH01020': 'BLUEJET',
  'INE0KCE01017': 'EUREKAFORB',
  'INE0KGZ01021': 'SIGNPOST',
  'INE0KKN01029': 'RHETAN',
  'INE0KL801015': 'DCXINDIA',
  'INE0KNT01012': 'MVGJL',
  'INE0KNW01016': 'KNAGRI',
  'INE0KQN01018': 'BAJEL',
  'INE0L0L01012': 'MODIS',
  'INE0L4K01016': 'VITAL',
  'INE0L9R01028': 'GOPAL',
  'INE0LCL01028': 'AVALON',
  'INE0LEZ01016': 'ATHERENERG',
  'INE0LGX01024': 'INA',
  'INE0LLY01014': 'EIEL',
  'INE0LMW01024': 'CELLO',
  'INE0LOJ01019': 'IKIO',
  'INE0LP301011': 'PWL',
  'INE0LQS01015': 'TIPSFILMS',
  'INE0LRU01027': 'AARTIPHARM',
  'INE0LRY01011': 'QUADFUTURE',
  'INE0LXG01040': 'OLAELEC',
  'INE0LXT01019': 'REDTAPE',
  'INE0LZF01013': 'CORDELIA',
  'INE0M4D01010': 'SETL',
  'INE0MB501011': 'JGCHEM',
  'INE0MEG01014': 'VIVIANA',
  'INE0MHO01029': 'REGAAL',
  'INE0MIS01010': 'PYRAMID',
  'INE0MLS01022': 'EPACKPEB',
  'INE0MWH01014': 'TRUALT',
  'INE0N0Y01013': 'USK',
  'INE0N2P01017': 'RISHABH',
  'INE0N7W01012': 'BLAL',
  'INE0NAZ01010': 'SMARTWORKS',
  'INE0NLT01010': 'BLSE',
  'INE0NN701020': 'ATL',
  'INE0NNS01018': 'NSLNISP',
  'INE0NQ801033': 'RKSWAMY',
  'INE0NT901020': 'NETWEB',
  'INE0O3901029': 'TREL',
  'INE0O6601022': 'KROSS',
  'INE0O9T01021': 'BAJAJINDEF',
  'INE0OAF01028': 'JNKINDIA',
  'INE0OC301013': 'TURTLEMINT',
  'INE0OFM01015': 'DSFCL',
  'INE0OJW01016': 'ROSSTECH',
  'INE0ONG01011': 'NTPCGREEN',
  'INE0OPA01027': 'DBEIL',
  'INE0OU201013': 'DCMSIL',
  'INE0OV601013': 'EMSLIMITED',
  'INE0P6P01016': 'CPEDU',
  'INE0P8B01020': 'GAUDIUMIVF',
  'INE0PA801013': 'GHCLTEXTIL',
  'INE0PB301013': 'SCILAL',
  'INE0PEQ01016': 'RBZJEWEL',
  'INE0PK601023': 'OCCLLTD',
  'INE0PKD01011': 'MEIL',
  'INE0PPK01015': 'ORIENTTECH',
  'INE0PQ101010': 'SSDL',
  'INE0PSC01024': 'DIGIDRIVE',
  'INE0PT501018': 'PLATIND',
  'INE0Q3J01015': 'KRN',
  'INE0Q3R01026': 'SUNCLAY',
  'INE0Q9301021': 'IGIL',
  'INE0QN801017': 'KRYSTAL',
  'INE0QPI01025': 'SUDEEPPHRM',
  'INE0QRL01017': 'ARKADE',
  'INE0QTF01015': 'VSTL',
  'INE0R4L01018': 'DENTA',
  'INE0R6Z01013': 'SRM',
  'INE0R8B01010': 'PATELRMART',
  'INE0RB801010': 'SENORES',
  'INE0RE001014': 'GALAPREC',
  'INE0RWQ01014': 'TOLINS',
  'INE0RYC01010': 'STALLION',
  'INE0S2G01011': 'BALAJEE',
  'INE0S2V01010': 'VRAJ',
  'INE0S3G01027': 'PACEDIGITK',
  'INE0S4R01014': 'CRIZAC',
  'INE0SII01026': 'QPOWER',
  'INE0SJA01013': 'VMSTMT',
  'INE0TGX01019': 'CHEMBONDCH',
  'INE0TO701015': 'MAMATA',
  'INE0TQE01026': 'GLOTTIS',
  'INE0TY101024': 'SOLARWORLD',
  'INE0U3I01011': 'UNIMECH',
  'INE0U4101014': 'BLUSPRING',
  'INE0U4701011': 'DIGITIDE',
  'INE0UH301010': 'OMNI',
  'INE0UIZ01018': 'BLACKBUCK',
  'INE0UOS01011': 'SANOFICONR',
  'INE0URU01010': 'GLOBALE',
  'INE0US801024': 'MFML',
  'INE0V0W01025': 'GKSL',
  'INE0V3U01015': 'GLOBECIVIL',
  'INE0V6F01027': 'HYUNDAI',
  'INE0V7W01012': 'CARRARO',
  'INE0V9Q01010': 'LOTUSDEV',
  'INE0VDM01015': 'MEESHO',
  'INE0VOV01021': 'DEVX',
  'INE0W2G01015': 'SAGILITY',
  'INE0WO601020': 'LAXMIDENTL',
  'INE0XAD01024': 'MIDWESTLTD',
  'INE0Y8W01025': 'AHCL',
  'INE0YD401026': 'JAINREC',
  'INE0Z4F01028': 'ATLANTAELE',
  'INE0ZK601013': 'CSM',
  'INE100A01010': 'ATUL',
  'INE100D01014': 'WSI',
  'INE101A01026': 'M&M',
  'INE101D01020': 'GRANULES',
  'INE101I01011': 'AFCONS',
  'INE102A01024': 'HLVLTD',
  'INE102B01014': 'CHOICEIN',
  'INE102D01028': 'GODREJCP',
  'INE102I01027': 'ADSL',
  'INE103A01014': 'MRPL',
  'INE103C01036': 'SMCGLOBAL',
  'INE103V01028': 'TRAVELFOOD',
  'INE105A01035': 'TVSHLTD',
  'INE105C01023': '3PLAND',
  'INE105I01020': 'SELMC',
  'INE105J01010': 'RPGLIFE',
  'INE106I01010': 'ANKITMETAL',
  'INE106T01025': 'HITECH',
  'INE107A01015': 'TNPL',
  'INE107F01022': 'WANBURY',
  'INE108E01023': 'SUNDARAM',
  'INE108V01019': 'AWFIS',
  'INE109A01011': 'SCI',
  'INE109C01017': 'ARMANFIN',
  'INE110A01019': 'BPL',
  'INE110B01017': 'MINDTECK',
  'INE111A01025': 'CONCOR',
  'INE111B01023': '63MOONS',
  'INE111F01024': 'PAUSHAKLTD',
  'INE111Q01021': 'PDSL',
  'INE112D01035': 'MHLXMIRU',
  'INE112F01022': 'LAMBODHARA',
  'INE112L01020': 'METROPOLIS',
  'INE112X01025': 'SIKKO',
  'INE113A01013': 'GNFC',
  'INE114A01011': 'SAIL',
  'INE115A01026': 'LICHSGFIN',
  'INE115Q01022': 'IKS',
  'INE115S01010': 'HALDER',
  'INE116A01032': 'APCOTEXIND',
  'INE116C01012': 'ZFSTEERING',
  'INE116D01028': 'BAGFILMS',
  'INE116G01013': 'VARDHACRLC',
  'INE117A01022': 'ABB',
  'INE117B01020': 'CURAA',
  'INE117Z01011': 'NARMADA',
  'INE118A01012': 'BAJAJHLDNG',
  'INE118D01016': 'NUVOCO',
  'INE118H01025': 'BSE',
  'INE119201023': 'PARKHOSPS',
  'INE119A01028': 'BALRAMCHIN',
  'INE120A01034': 'CARBORUNIV',
  'INE120D01012': 'HITECHCORP',
  'INE121A01024': 'CHOLAFIN',
  'INE121E01018': 'JSWENERGY',
  'INE121J01017': 'INDUSTOWER',
  'INE121N01019': 'THEJO',
  'INE121R01077': 'AMAGI',
  'INE122M01019': 'ESSARSHPNG',
  'INE123B01028': 'NAGREEKEXP',
  'INE123C01018': 'TAINWALCHM',
  'INE123F01029': 'MMTC',
  'INE123W01016': 'SBILIFE',
  'INE124E01038': 'STEELCAS',
  'INE124G01033': 'DELTACORP',
  'INE124Y01028': 'PASHUPATI',
  'INE126A01031': 'EIDPARRY',
  'INE126J01016': 'APOLLOPIPE',
  'INE126M01010': 'IBULLSLTD',
  'INE127B01011': 'HITECHGEAR',
  'INE127D01025': 'HDFCAMC',
  'INE127I01024': 'GOODLUCK',
  'INE127T01021': 'KPEL',
  'INE128A01029': 'EVEREADY',
  'INE128S01021': 'FIVESTAR',
  'INE128X01021': 'ACI',
  'INE129A01019': 'GAIL',
  'INE129Z01016': 'SINTERCOM',
  'INE12F801023': 'KISSHT',
  'INE12NJ01018': 'SAMBHV',
  'INE12UN01015': 'SHADOWFAX',
  'INE12UR01024': 'UTLSOLAR',
  'INE130B01031': 'SURANAT&P',
  'INE131A01031': 'GMDCLTD',
  'INE131B01039': 'RELAXO',
  'INE131C01011': 'DISAQ',
  'INE132C01027': 'SURYALA',
  'INE132H01018': 'AURIONPRO',
  'INE133A01011': 'JSWDULUX',
  'INE133E01013': 'TI',
  'INE133Y01011': 'IFGLEXPOR',
  'INE134B01017': 'KECL',
  'INE134E01011': 'PFC',
  'INE136B01020': 'CYIENT',
  'INE136S01016': 'NEOGEN',
  'INE137C01018': 'ALPHAGEO',
  'INE137I01015': 'GRPLTD',
  'INE138A01028': 'PENINLAND',
  'INE138C01024': 'KANORICHEM',
  'INE138Y01010': 'KFINTECH',
  'INE139A01034': 'NATIONALUM',
  'INE139B01016': 'UCAL',
  'INE139I01011': 'BVCL',
  'INE139R01012': 'FUSION',
  'INE13B501022': 'SAATVIKGL',
  'INE141D01018': 'TNTELE',
  'INE141K01013': 'TEXMOPIPES',
  'INE142A01012': 'OSWALAGRO',
  'INE142I01023': 'TAKE',
  'INE142K01011': 'AURUS',
  'INE142M01025': 'TATATECH',
  'INE142Q01026': 'SULA',
  'INE142Z01019': 'ORIENTELEC',
  'INE143A01010': 'OSWALGREEN',
  'INE144D01012': 'CUBEXTUB',
  'INE144J01027': '20MICRONS',
  'INE144Z01023': 'TARSONS',
  'INE146L01010': 'KIRLOSENG',
  'INE147A01011': 'SPIC',
  'INE147P01019': 'JPOLYINVST',
  'INE148A01019': 'TNPETRO',
  'INE148I01020': 'SAMMAANCAP',
  'INE148O01028': 'DELHIVERY',
  'INE149A01033': 'CHOLAHLDNG',
  'INE149K01016': 'SANDUMA',
  'INE149O01018': 'NIBE',
  'INE14LE01019': 'ABLBL',
  'INE14UN01029': 'VIDYAWIRES',
  'INE150B01039': 'ALKYLAMINE',
  'INE150G01020': 'LUXIND',
  'INE151A01013': 'TATACOMM',
  'INE151G01028': 'SHAILY',
  'INE152A01029': 'THERMAX',
  'INE152C01025': 'UYFINCORP',
  'INE152M01016': 'TRITURBINE',
  'INE153A01019': 'MTNL',
  'INE153T01027': 'BLS',
  'INE154A01025': 'ITC',
  'INE155A01022': 'TMPV',
  'INE155C01010': 'ALBERTDAVD',
  'INE155E01016': 'INVPRECQ',
  'INE155G01029': 'NDTV',
  'INE155Z01011': 'MACPOWER',
  'INE156A01020': 'INDORAMA',
  'INE156C01018': 'PIONEEREMB',
  'INE157H01023': 'KMSUGAR',
  'INE158A01026': 'HEROMOTOCO',
  'INE158B01016': 'EIMCOELECO',
  'INE159A01016': 'GLAXO',
  'INE159N01027': 'VIJIFIN',
  'INE15B701018': 'PINELABS',
  'INE160A01022': 'PNB',
  'INE161A01038': 'NIITLTD',
  'INE161G01027': 'MORARJEE',
  'INE161L01027': 'VIKASLIFE',
  'INE162A01010': 'GIPCL',
  'INE162B01018': 'LUMAXIND',
  'INE162C01024': 'PARASPETRO',
  'INE163A01018': 'NOCIL',
  'INE164A01016': 'BALMLAWRIE',
  'INE164B01030': 'KELLTONTEC',
  'INE165B01029': 'RSSOFTWARE',
  'INE166R01015': 'NATIONSTD',
  'INE168A01041': 'J&KBANK',
  'INE168P01015': 'EMCURE',
  'INE169A01031': 'COROMANDEL',
  'INE16NZ01023': 'ORKLAINDIA',
  'INE16SF01016': 'BORANA',
  'INE170E01023': 'SATIA',
  'INE170I01016': 'HGS',
  'INE170V01027': 'SALASAR',
  'INE171A01029': 'FEDERALBNK',
  'INE171Z01026': 'BDL',
  'INE172A01027': 'CASTROLIND',
  'INE172N01012': 'IMAGICAA',
  'INE173A01025': 'SIL',
  'INE175A01038': 'JISLJALEQS',
  'INE176A01028': 'BATAINDIA',
  'INE176B01034': 'HAVELLS',
  'INE176J01011': 'SICAGEN',
  'INE177A01018': 'INGERRAND',
  'INE177C01022': 'BATLIBOI',
  'INE177F01017': 'KOVAI',
  'INE177H01039': 'GPIL',
  'INE178A01016': 'CHENNPETRO',
  'INE178C01020': 'SMARTLINK',
  'INE179A01014': 'PGHH',
  'INE179G01029': 'DAVANGERE',
  'INE17QZ01016': 'KNACK',
  'INE180A01020': 'MFSL',
  'INE180C01042': 'CGCL',
  'INE182A01018': 'PFIZER',
  'INE182D01020': 'MARATHON',
  'INE183A01024': 'FINPIPE',
  'INE184H01027': 'EKC',
  'INE184O01015': 'DIFFNKG',
  'INE185C01017': 'SAPPL',
  'INE185E01021': 'FILATFASH',
  'INE185H01016': 'CELEBRITY',
  'INE186A01019': 'GUJALKALI',
  'INE186H01022': 'BASML',
  'INE187D01029': 'TALBROAUTO',
  'INE188A01015': 'FACT',
  'INE188B01013': 'IGARASHI',
  'INE188Y01031': 'VERTOZ',
  'INE189B01011': 'STYRENIX',
  'INE189I01024': 'NELCAST',
  'INE18JU01028': 'EBGNG',
  'INE190H01024': 'SAKUMA',
  'INE191A01027': 'ORCHPHARMA',
  'INE191B01025': 'WELCORP',
  'INE191H01014': 'PVRINOX',
  'INE191I01012': 'HDIL',
  'INE192A01025': 'TATACONSUM',
  'INE192B01031': 'WELSPUNLIV',
  'INE192H01020': 'GRMOVER',
  'INE192R01011': 'DMART',
  'INE193B01039': 'AYMSYNTEX',
  'INE193E01025': 'BAJAJELEC',
  'INE194D01017': 'ASTAR',
  'INE195A01028': 'SUPREMEIND',
  'INE195J01029': 'PNCINFRA',
  'INE195N01013': 'PROZONER',
  'INE196A01026': 'MARICO',
  'INE196Y01018': 'WORTHPERI',
  'INE197A01024': 'JYOTISTRUC',
  'INE197D01010': 'JINDALPOLY',
  'INE197J01017': 'LPDC',
  'INE198501012': 'EUROPRATIK',
  'INE198H01019': 'AAREYDRUGS',
  'INE199A01012': 'PGHL',
  'INE199C01026': 'ADVANIHOTR',
  'INE199G01027': 'JAGRAN',
  'INE199P01028': 'GCSL',
  'INE19GK01015': 'SRTL',
  'INE19RI01016': 'TENNIND',
  'INE1AG301022': 'GKENERGY',
  'INE1B0W01010': 'ADVANCE',
  'INE1B3L01017': 'SHRINGARMS',
  'INE1B6101010': 'SHREEJISPG',
  'INE1BZC01019': 'OMFREIGHT',
  'INE1C6T01020': 'EMMVEE',
  'INE1CDF01017': 'VAML',
  'INE1CLE01013': 'VISL',
  'INE1FF001016': 'JKIPL',
  'INE1NPP01017': 'ENRIN',
  'INE1RDG01013': 'PNGSREVA',
  'INE1SJO01012': 'RAMBHAJO',
  'INE1SPP01016': 'KSR',
  'INE1SY401010': 'RAYMONDREL',
  'INE1TAE01010': 'TMCV',
  'INE1VXE01018': 'STLNETWORK',
  'INE1YPB01014': 'AGL',
  'INE200A01026': 'GVT&D',
  'INE200D01020': 'MMWL',
  'INE200M01039': 'VBL',
  'INE201A01024': 'MANALIPETC',
  'INE201B01022': 'MAJESAUT',
  'INE201K01015': 'EXPLEOSOL',
  'INE201M01029': 'CLEDUCATE',
  'INE201P01022': 'GRINFRA',
  'INE202B01038': 'PIRAMALFIN',
  'INE202E01016': 'IREDA',
  'INE202H01019': 'KERNEX',
  'INE202Z01029': 'TSFINV',
  'INE203A01020': 'ASTRAZEN',
  'INE203G01027': 'IGL',
  'INE203Y01012': 'SILLYMONKS',
  'INE204A01010': 'IGPL',
  'INE204E01012': 'AGARIND',
  'INE205A01025': 'VEDL',
  'INE205B01031': 'ELECON',
  'INE205C01021': 'POLYMED',
  'INE206B01013': 'ZODIACLOTH',
  'INE206F01022': 'AIIL',
  'INE206N01018': 'RELTD',
  'INE207E01023': 'RAMRAT',
  'INE207H01018': 'GNRL',
  'INE208A01029': 'ASHOKLEY',
  'INE208C01025': 'AEGISLOG',
  'INE209A01019': 'SUNDROP',
  'INE209B01025': 'RICOAUTO',
  'INE209L01016': 'JWL',
  'INE210A01017': 'WILLAMAGOR',
  'INE210C01013': 'AROGRANITE',
  'INE211B01039': 'PHOENIXLTD',
  'INE211R01019': 'POWERMECH',
  'INE212H01026': 'AIAENG',
  'INE212I01016': 'SPAL',
  'INE212S01015': 'FRACTAL',
  'INE213A01029': 'ONGC',
  'INE213C01025': 'BANCOINDIA',
  'INE213D01015': 'BEEKAY',
  'INE214A01019': 'CYBERTECH',
  'INE214F01026': 'GRAVISSHO',
  'INE214T01019': 'LTM',
  'INE215B01022': 'ORCHASP',
  'INE215D01010': 'MAHEPC',
  'INE215F01023': 'WIPL',
  'INE215I01027': 'MAANALU',
  'INE216A01030': 'BRITANNIA',
  'INE216P01012': 'AAVAS',
  'INE217A01012': 'ZUARIIND',
  'INE217B01036': 'KAJARIACER',
  'INE217G01035': 'EQUIPPP',
  'INE217K01011': 'RHFL',
  'INE217L01019': 'SHRIRAMPPS',
  'INE218C01016': 'AUSOMENT',
  'INE218G01033': 'PALREDTEC',
  'INE218I01013': 'CRAMC',
  'INE219Y01026': 'RMDRIP',
  'INE220B01022': 'KPIL',
  'INE220G01021': 'JSL',
  'INE220Q01020': 'MUFTI',
  'INE220Z01013': 'SHINDL',
  'INE221B01012': 'DYNAMATECH',
  'INE221H01019': 'GTLINFRA',
  'INE221J01015': 'SHARDACROP',
  'INE224A01026': 'GREAVESCOT',
  'INE224E01028': 'GATECH',
  'INE224E01036': 'GATECHDVR',
  'INE225B01021': 'FERMENTA',
  'INE225D01027': 'SYMPHONY',
  'INE226A01021': 'VOLTAS',
  'INE226H01026': 'SADBHAV',
  'INE227C01017': 'MMFL',
  'INE227G01018': 'INDOWIND',
  'INE227J01012': 'KALPATARU',
  'INE227W01023': 'CLEAN',
  'INE228A01035': 'USHAMART',
  'INE228I01012': 'ASAHISONG',
  'INE229A01017': 'ONWARDTEC',
  'INE229C01021': 'SAGCEM',
  'INE229H01012': 'NITINSPIN',
  'INE230A01023': 'EIHOTEL',
  'INE230B01021': 'CREATIVEYE',
  'INE230R01035': 'RAMASTEEL',
  'INE231C01019': 'SHREYANIND',
  'INE231F01020': 'SASKEN',
  'INE231G01010': 'ORBTEXP',
  'INE232A01011': 'SHREDIGCEM',
  'INE232E01013': 'VELJAN',
  'INE232I01014': 'SPARC',
  'INE233A01035': 'GODREJIND',
  'INE233B01017': 'BLUEDART',
  'INE234A01025': 'NOVARTIND',
  'INE234I01028': 'KAUSHALYA',
  'INE235A01022': 'FINCABLES',
  'INE235C01036': 'SUMEETINDS',
  'INE235C20010': 'SUMEET-RE',
  'INE236A01020': 'HCL-INSYS',
  'INE236E01022': 'ELLEN',
  'INE236G01019': 'TVSELECT',
  'INE236Y01012': 'NGIL',
  'INE237A01036': 'KOTAKBANK',
  'INE238A01034': 'AXISBANK',
  'INE239A01024': 'NESTLEIND',
  'INE239C01020': 'STYLAMIND',
  'INE239D01028': 'OMINFRAL',
  'INE240C01028': 'UMESLTD',
  'INE242A01010': 'IOC',
  'INE242C01024': 'ANANTRAJ',
  'INE243D01012': 'BFUTILITIE',
  'INE244A01016': 'DENORA',
  'INE244B01030': 'PATELENG',
  'INE244O01017': 'UNIPARTS',
  'INE245A01021': 'TATAPOWER',
  'INE245I01016': 'NAGREEKCAP',
  'INE246B01019': 'RAMCOSYS',
  'INE247D01039': 'JINDWORLD',
  'INE247M01014': 'SPECIALITY',
  'INE248A01017': 'ITI',
  'INE249Z01020': 'MAZDOCK',
  'INE24OJ01011': 'BUILDPRO',
  'INE250A01039': 'KIRLOSIND',
  'INE250B01029': 'VINYLINDIA',
  'INE250K01012': 'DLINKINDIA',
  'INE250Z01010': 'INDOUS',
  'INE251B01027': 'ZENTEC',
  'INE251C01025': 'ABMINTLLTD',
  'INE251H01024': 'GVKPIL',
  'INE253B01015': '21STCENMGM',
  'INE254N01026': 'HNDFDS',
  'INE255A01020': 'EPL',
  'INE255D01024': 'GULPOLY',
  'INE255X01014': 'MSTCLTD',
  'INE255Z01027': 'E2E',
  'INE256A01028': 'ZEEL',
  'INE256C01024': 'TRIVENI',
  'INE256H01015': 'DYNPRO',
  'INE256Z01025': 'AKSHAR',
  'INE257A01026': 'BHEL',
  'INE258A01024': 'BEML',
  'INE258B01022': 'FDC',
  'INE258G01013': 'SUMICHEM',
  'INE258Y01016': 'LGHL',
  'INE259A01022': 'COLPAL',
  'INE25E901019': 'OMPOWER',
  'INE260B01028': 'GODFRYPHLP',
  'INE260D01016': 'OLECTRA',
  'INE262A01018': 'HMT',
  'INE262H01021': 'PERSISTENT',
  'INE262Z01023': 'LATTEYS',
  'INE263A01024': 'BEL',
  'INE263M01029': 'RUSTOMJEE',
  'INE263W01010': 'MAHESHWARI',
  'INE264T01014': 'CAPACITE',
  'INE265B01019': 'NITTAGELA',
  'INE265F01028': 'ENIL',
  'INE266D01021': 'GRAUWEIL',
  'INE266F01018': 'APTECHT',
  'INE266Y01019': 'DPABHUSHAN',
  'INE267A01025': 'HINDZINC',
  'INE268B01013': 'KREBSBIO',
  'INE268H01044': 'NAVKARURB',
  'INE268L01046': 'SHEKHAWATI',
  'INE269A01021': 'SONATSOFTW',
  'INE269B01029': 'LMW',
  'INE270A01029': 'ALOKINDS',
  'INE270B01035': 'MAFATIND',
  'INE270I01022': 'VISHNU',
  'INE271B01025': 'MAHSEAMLES',
  'INE271C01023': 'DLF',
  'INE272L01022': 'SURANASOL',
  'INE273D01027': 'VGL',
  'INE274C01019': 'WENDT',
  'INE274F01020': 'WESTLIFE',
  'INE274J01014': 'OIL',
  'INE274K01012': 'BTTL',
  'INE274V01019': 'SHANKARA',
  'INE274Y01021': 'AJAXENGG',
  'INE275B01026': 'HUHTAMAKI',
  'INE275D01022': 'AMNPLST',
  'INE276A01018': 'GARFIBRES',
  'INE276C01014': 'EIHAHOTELS',
  'INE276G01015': 'ASIANENE',
  'INE277A01016': 'SWARAJENG',
  'INE277B01014': 'PUNJABCHEM',
  'INE277C01012': 'REGENCERAM',
  'INE278B01020': 'RAMANEWS',
  'INE278G01037': 'CYBERMEDIA',
  'INE278H01035': 'SANDHAR',
  'INE278M01019': 'NAVKARCORP',
  'INE278R01034': 'DHARAN',
  'INE278Y01022': 'CAMPUS',
  'INE279A01012': 'UNIVCABLES',
  'INE280A01028': 'TITAN',
  'INE280B01018': 'ELANTAS',
  'INE280H01015': 'SAHYADRI',
  'INE281A01026': 'CENTEXT',
  'INE281B01032': 'LLOYDSME',
  'INE283A01014': 'PRECOT',
  'INE283H01019': 'ROHLTD',
  'INE284A01012': 'ESABINDIA',
  'INE284H01025': 'DAMCAPITAL',
  'INE284S01014': 'SJS',
  'INE285A01027': 'ELGIEQUIP',
  'INE285H01022': 'ATLANTAA',
  'INE285J01028': 'SIS',
  'INE285K01026': 'TECHNOE',
  'INE286H01012': 'VISACHROME',
  'INE287B01021': 'SUBROS',
  'INE287C01037': 'MICEL',
  'INE287Z01012': 'GAYAHWS',
  'INE288A01013': 'MAHSCOOTER',
  'INE288B01029': 'DEEPAKNTR',
  'INE289A01011': 'NAHARINDUS',
  'INE289B01019': 'GICHSGFIN',
  'INE289C01025': 'TEAMGTY',
  'INE28GN01010': 'ADVENTHTL',
  'INE290A01027': 'NAHARSPING',
  'INE290S01011': 'CARTRADE',
  'INE291A01017': 'GRWRHITECH',
  'INE291D01011': 'KDDL',
  'INE291E01019': 'PML',
  'INE291W01037': 'GLOBAL',
  'INE292B01021': 'HBLENGINE',
  'INE293B01029': 'HAVISHA',
  'INE294B01019': 'SMLMAH',
  'INE294G01026': 'ROML',
  'INE294Z01018': 'ANUP',
  'INE295A01018': 'EVERESTIND',
  'INE295D01020': 'NACLIND',
  'INE295F01017': 'BUTTERFLY',
  'INE296A01032': 'BAJFINANCE',
  'INE296C01020': 'FIBERWEB',
  'INE296E01026': 'RAJPALAYAM',
  'INE296G01013': 'MUTHOOTCAP',
  'INE296H01011': 'EMKAY',
  'INE296Q01012': 'MONEYBOXX',
  'INE297H01019': 'GALLANTT',
  'INE298A01020': 'CUMMINSIND',
  'INE298G01035': 'AJMERA',
  'INE298I01015': 'ARIES',
  'INE298J01013': 'NAM-INDIA',
  'INE299N01021': 'WAAREERTL',
  'INE299U01018': 'CROMPTON',
  'INE2FMX01012': 'AASTHA',
  'INE2J8701016': 'SKFINDUS',
  'INE2KCE01013': 'KWIL',
  'INE301A01014': 'RAYMOND',
  'INE301D01026': 'RUBYMILLS',
  'INE302A01020': 'EXIDEIND',
  'INE303A01010': 'DICIND',
  'INE303R01014': 'KALYANKJIL',
  'INE304A01026': 'MUKANDLTD',
  'INE304W01038': 'BLUESTONE',
  'INE305A01023': 'TFCILTD',
  'INE305C01029': 'PANAMAPET',
  'INE306A01021': 'BAJAJHIND',
  'INE306C01019': 'ENERGYDEV',
  'INE306L01010': 'QUICKHEAL',
  'INE306R01017': 'INTELLECT',
  'INE308A01027': 'NAHARPOLY',
  'INE308E01029': 'SVPGLOB',
  'INE309M01020': 'PREMIERPOL',
  'INE310A01015': 'NILKAMAL',
  'INE310C01029': 'HINDCOMPOS',
  'INE312C01025': 'SYNCOMF',
  'INE313L01016': 'RSL',
  'INE314C01013': 'SOMATEX',
  'INE314G01014': 'KALYANIFRG',
  'INE314H01012': 'TECHNVISN',
  'INE314T01033': 'GOKULAGRO',
  'INE316L01019': 'BHARATWIRE',
  'INE317F01035': 'NESCO',
  'INE317I01021': 'METROBRAND',
  'INE318A01026': 'PIDILITIND',
  'INE318C01014': 'SAYAJIHOTL',
  'INE318D01020': 'ZENITHSTL',
  'INE319B01014': 'BYKE',
  'INE319Y01024': 'TIRUPATIFL',
  'INE319Z01021': 'SUPREMEENG',
  'INE320B01020': 'CENTUM',
  'INE320J01015': 'RITES',
  'INE320L01011': 'DHUNINV',
  'INE320X01016': 'HALEOSLABS',
  'INE321M01017': 'SONAL',
  'INE321T01012': 'DOMS',
  'INE322A01010': 'GILLETTE',
  'INE323A01026': 'BOSCHLTD',
  'INE323B01024': 'AVONMORE',
  'INE323C01030': 'INDIANHUME',
  'INE323I01011': 'PURVA',
  'INE323J01019': 'SOMICONVEY',
  'INE324A01032': 'JINDALSAW',
  'INE324D01010': 'LGEINDIA',
  'INE324L01013': 'RPPINFRA',
  'INE324X01026': 'SARVESHWAR',
  'INE325A01013': 'TIMKEN',
  'INE325C01035': 'DOLLAR',
  'INE325D01025': 'SINDHUTRAD',
  'INE326A01037': 'LUPIN',
  'INE326B01035': 'ALMONDZ',
  'INE326T01011': 'NIRAJISPAT',
  'INE330H01018': 'RCOM',
  'INE330T01021': 'HAPPYFORGE',
  'INE331A01037': 'RAMCOCEM',
  'INE332A01027': 'THOMASCOOK',
  'INE332H01014': 'INDOTECH',
  'INE333I01044': 'NEUEON',
  'INE334A01023': 'STERTOOLS',
  'INE335A01020': 'SURYAROSNI',
  'INE335K01011': 'COFFEEDAY',
  'INE335W01016': 'GANGESSECU',
  'INE335Y01020': 'IRCTC',
  'INE336H01023': 'GAYAPROJ',
  'INE336X01012': 'TOTAL',
  'INE337A01034': 'LGBBROSLTD',
  'INE337M01021': 'INDOTHAI',
  'INE338A01024': 'TIRUMALCHM',
  'INE338D01028': 'BODALCHEM',
  'INE338F01015': 'KLBRENG-B',
  'INE338H01029': 'CONCORDBIO',
  'INE338I01027': 'MOTILALOFS',
  'INE340A01012': 'BIRLACORPN',
  'INE341R01014': 'DTIL',
  'INE342A01018': 'PREMIER',
  'INE342G01023': 'NIITMTS',
  'INE342J01019': 'ZFCVINDIA',
  'INE343B01030': 'RAJESHEXPO',
  'INE343G01021': 'BHARTIHEXA',
  'INE343H01029': 'SOLARINDS',
  'INE344S01016': 'INFOBEAN',
  'INE344T01014': 'BELLACASA',
  'INE345A01011': 'HINDOILEXP',
  'INE345B01019': 'CEREBRAINT',
  'INE345H01024': 'CIFL',
  'INE346A01027': 'ICICIAMC',
  'INE346W01013': 'APEX',
  'INE347A01017': 'MANGLMCEM',
  'INE347G01014': 'PETRONET',
  'INE347W01011': 'MAGADSUGAR',
  'INE348A01023': 'ASHAPURMIN',
  'INE348B01021': 'CENTURYPLY',
  'INE348L01012': 'MASFIN',
  'INE349A01021': 'NRBBEARING',
  'INE349W01017': 'AVADHSUGAR',
  'INE349Y01013': 'IDEAFORGE',
  'INE350C01017': 'OPTIEMUS',
  'INE350H01032': 'BLKASHYAP',
  'INE350Z01018': 'GLOSTERLTD',
  'INE351A01035': 'UNICHEMLAB',
  'INE351F01018': 'JPPOWER',
  'INE351Y01019': 'BETA',
  'INE353A01023': 'NDLVENTURE',
  'INE353H01010': 'SGL',
  'INE353K01014': 'ITDC',
  'INE354C01027': 'BHAGERIA',
  'INE355A01028': 'SOMANYCERA',
  'INE356A01018': 'MPHASIS',
  'INE356B01024': 'SYSTMTXC',
  'INE358A01014': 'ABBOTINDIA',
  'INE358U01012': 'ZOTA',
  'INE360C01024': 'DPSCLTD',
  'INE360L01017': 'FMNL',
  'INE361B01024': 'DIVISLAB',
  'INE361K01017': 'GRADIENTE',
  'INE362A01016': 'PVP',
  'INE363A01022': 'ASIANHOTNR',
  'INE363M01019': 'SHEMAROO',
  'INE364A01020': 'JAYSREETEA',
  'INE364U01010': 'ADANIGREEN',
  'INE364Z01019': 'REPL',
  'INE365B01017': 'DATAMATICS',
  'INE365D01021': 'ASHIANA',
  'INE365I01020': 'NBIFIN',
  'INE365O01028': 'ABANSENT',
  'INE366A01041': 'DWARKESH',
  'INE366C01021': 'ACSTECH',
  'INE366I01010': 'VRLLOG',
  'INE367G01038': 'PFOCUS',
  'INE368I01016': 'NIRAJ',
  'INE368U01029': 'UNITEDPOLY',
  'INE369A01029': 'EXCELINDUS',
  'INE369C01017': 'NORBTEAEXP',
  'INE369I01014': 'IL&FSENGG',
  'INE370D01013': 'MANORG',
  'INE370E01029': 'VIVIDHA',
  'INE371A01025': 'GRAPHITE',
  'INE371C01013': 'PODDARMENT',
  'INE371P01015': 'AMBER',
  'INE372A01015': 'APARINDS',
  'INE372C01037': 'PRECWIRE',
  'INE372E01025': 'BIRLAPREC',
  'INE373A01013': 'BASF',
  'INE374B01019': 'MUKTAARTS',
  'INE375Y01018': 'RELIABLE',
  'INE376G01013': 'BIOCON',
  'INE377E01024': 'COASTCORP',
  'INE377N01017': 'WAAREEENER',
  'INE377Y01014': 'BAJAJHFL',
  'INE378D01032': 'MADHUCON',
  'INE379A01028': 'ITCHOTELS',
  'INE382M01027': 'UFBL',
  'INE382T01030': 'GVPTECH',
  'INE382Z01011': 'GRSE',
  'INE383A01012': 'INDIACEM',
  'INE383H01017': 'MALUPAPER',
  'INE384A01010': 'RANEHOLDIN',
  'INE384C01016': 'YUKEN',
  'INE385C01021': 'SARDAEN',
  'INE385F01024': 'SGMART',
  'INE385I01010': 'ALPA',
  'INE385W01011': 'DCAL',
  'INE386A01023': 'VESUVIUS',
  'INE386C01029': 'ASTRAMICRO',
  'INE386D01027': 'SBCL',
  'INE387A01021': 'SUNDRMFAST',
  'INE387I01016': 'MAGNUM',
  'INE388A01029': 'GANESHBE',
  'INE388G01026': 'TICL',
  'INE388Y01029': 'NYKAA',
  'INE389C01015': 'MALLCOM',
  'INE389H01022': 'KEC',
  'INE389K01018': 'WELINV',
  'INE390G01014': 'GPTINFRA',
  'INE390H01020': 'KAMDHENU',
  'INE391D01019': 'TRF',
  'INE391J01032': 'JTLIND',
  'INE392A01021': 'VISAKAIND',
  'INE392B01011': 'PNC',
  'INE393A01011': 'DELTAMAGNT',
  'INE393P01035': 'DIAMONDYD',
  'INE395H01011': 'STEELCITY',
  'INE395N01027': 'TVSSCS',
  'INE395U01014': 'NINSYS',
  'INE397D01024': 'BHARTIARTL',
  'INE397H01017': 'LOKESHMACH',
  'INE398A01010': 'VENKEYS',
  'INE398B01018': 'UMIYA-MRO',
  'INE398R01022': 'SYNGENE',
  'INE399C01030': 'SUPRAJIT',
  'INE399G01023': 'RKFORGE',
  'INE399K01017': 'RTNPOWER',
  'INE399L01023': 'ATGL',
  'INE401H01017': 'KKCL',
  'INE402H01015': 'SHBAJRG',
  'INE403F01017': 'THAKDEV',
  'INE403Y01018': 'INNOVANA',
  'INE404A01024': 'ABSLAMC',
  'INE405A01021': 'ULTRAMAR',
  'INE405C01035': 'LINCOLN',
  'INE405E01023': 'UNOMINDA',
  'INE406A01037': 'AUROPHARMA',
  'INE406M01024': 'ERIS',
  'INE409B01013': 'SWELECTES',
  'INE410B01037': 'VINATIORGA',
  'INE410P01011': 'NH',
  'INE411B01019': 'VENUSREM',
  'INE411D01023': 'SKMEGGPROD',
  'INE411F01010': 'KAMAHOLD',
  'INE411H01032': 'RSYSTEMS',
  'INE411U01027': 'BAJAJHCARE',
  'INE412C01023': 'JMA',
  'INE412G01024': 'BCLIND',
  'INE412U01025': 'BIGBLOC',
  'INE413B01023': 'RUCHINFRA',
  'INE413D01011': 'ARIHANT',
  'INE413G01022': 'TPLPLASTEH',
  'INE414A01015': 'MADRASFERT',
  'INE414B01021': 'ANTGRAPHIC',
  'INE414D01027': 'BHAGCHEM',
  'INE414G01012': 'MUTHOOTFIN',
  'INE415A01038': 'AGI',
  'INE415B01044': 'MARSONS',
  'INE415D01024': 'BHARATSE',
  'INE415G01027': 'RVNL',
  'INE415I01015': 'KIRIINDUS',
  'INE416A01051': 'AQYLON',
  'INE416D01022': 'BLISSGVS',
  'INE417B01040': 'DSSL',
  'INE417C01014': 'PILANIINVS',
  'INE417D01020': 'FEDDERSHOL',
  'INE417T01026': 'POLICYBZR',
  'INE418H01029': 'ALLCARGO',
  'INE418L01047': 'NAZARA',
  'INE418N01035': 'ESSENTIA',
  'INE419A01022': 'KOTARISUG',
  'INE419D01026': 'CLSEL',
  'INE419M01027': 'TDPOWERSYS',
  'INE419U01012': 'HAPPSTMNDS',
  'INE420B01036': 'ARIHANTCAP',
  'INE420C01059': 'PAISALO',
  'INE421A01028': 'ABAN',
  'INE421C01016': 'TVSSRICHAK',
  'INE421D01022': 'CCL',
  'INE423A01024': 'ADANIENT',
  'INE423Y01016': 'SBFC',
  'INE424C01010': 'GINNIFILA',
  'INE424H01027': 'SUNTV',
  'INE425B01027': 'BCG',
  'INE425Y01011': 'RPSGVENT',
  'INE426A01027': 'ALEMBICLTD',
  'INE426D01013': 'GOACARBON',
  'INE426Z01016': 'OBCL',
  'INE427F01016': 'CHALET',
  'INE428Q01011': 'SURYODAY',
  'INE428V01029': 'NEPHROPLUS',
  'INE429E01023': 'SAFARI',
  'INE429I01024': 'CCCL',
  'INE430N01022': 'VISHWARAJ',
  'INE431F01018': 'PKTEA',
  'INE432A01017': 'AMBALALSA',
  'INE435A01051': 'ANDHRAPAP',
  'INE435C01024': 'TEXINFRA',
  'INE435D01014': 'MCCHRLS-B',
  'INE435G01025': 'DHANUKA',
  'INE436A01026': 'ANSALAPI',
  'INE437A01024': 'APOLLOHOSP',
  'INE437B01014': 'KAKATCEM',
  'INE438A01022': 'APOLLOTYRE',
  'INE438E01032': 'SIKA',
  'INE438K01021': 'KALAMANDIR',
  'INE439A01020': 'ASAHIINDIA',
  'INE439E01022': 'SKIPPER',
  'INE439T01012': 'NITIRAJ',
  'INE440A01010': 'ASHIMASYN',
  'INE440L01017': 'TIJARIA',
  'INE440T01028': 'SEIL',
  'INE442H01029': 'ASHOKA',
  'INE442P01014': 'SUYOG',
  'INE445C01015': 'XPROINDIA',
  'INE445D01013': 'NILE',
  'INE446A01025': 'ATLASCYCLE',
  'INE448G01010': 'NATHBIOGEN',
  'INE449A01011': 'AUTOAXLES',
  'INE449G01018': 'AGRITECH',
  'INE450D01021': 'PITTIENG',
  'INE450E01029': 'SUKHJITS',
  'INE450G01024': 'VIPCLOTHNG',
  'INE450U01017': 'ROUTE',
  'INE451A01017': 'FORCEMOT',
  'INE451D01029': 'RAJRATAN',
  'INE451F01024': 'APOLSINHOT',
  'INE451L01014': 'MAHASTEEL',
  'INE452L01012': 'INCREDIBLE',
  'INE452O01016': 'FLFL',
  'INE453B01029': 'COMPUSOFT',
  'INE453D01025': 'SARLAPOLY',
  'INE454P01035': 'TRANSRAILL',
  'INE455I01029': 'KSCL',
  'INE455K01017': 'POLYCAB',
  'INE456Z01021': 'MEDIASSIST',
  'INE457A01014': 'MAHABANK',
  'INE457F01013': 'SALZERELEC',
  'INE457L01029': 'PGEL',
  'INE458B01036': 'BHAGYANGR',
  'INE458F01011': 'UNITEDTEA',
  'INE459A01010': 'BANARISUG',
  'INE460C01014': 'GANESHHOU',
  'INE460H01021': 'STARCEMENT',
  'INE461B01014': 'REPRO',
  'INE461C01038': 'GREENPLY',
  'INE461D01028': 'HLEGLAS',
  'INE462A01022': 'BAYERCROP',
  'INE463A01038': 'BERGEPAINT',
  'INE463V01026': 'ANANDRATHI',
  'INE464A01036': 'BBL',
  'INE465A01025': 'BHARATFORG',
  'INE466L01038': '360ONE',
  'INE467B01029': 'TCS',
  'INE469A01019': 'BIMETAL',
  'INE470A01017': '3MINDIA',
  'INE470Y01017': 'NIACL',
  'INE471W01019': 'PALASHSECU',
  'INE472A01039': 'BLUESTARCO',
  'INE472B01011': 'BLUECOAST',
  'INE472M01018': 'MTEDUCARE',
  'INE473A01011': 'LINDEINDIA',
  'INE473B01035': 'HATSUN',
  'INE473D01015': 'KINGFA',
  'INE474C01023': 'REMSONSIND',
  'INE474E01029': 'BHANDARI',
  'INE474Q01031': 'MEDANTA',
  'INE475B01022': 'HIKAL',
  'INE475E01026': 'CAPLIPOINT',
  'INE476A01022': 'CANBK',
  'INE477A01020': 'CANFINHOME',
  'INE477B01010': 'DVL',
  'INE479D01038': 'KRITI',
  'INE480C01038': 'SDBL',
  'INE480M01011': 'THOMASCOTT',
  'INE481G01011': 'ULTRACEMCO',
  'INE481N01025': 'HOMEFIRST',
  'INE481Y01014': 'GICRE',
  'INE481Z01011': 'UNIINFO',
  'INE482A01020': 'CEATLTD',
  'INE482B01010': 'TERASOFT',
  'INE482D01024': 'CARYSIL',
  'INE482J01021': 'SHAH',
  'INE483A01010': 'CENTRALBK',
  'INE483B01026': 'ICIL',
  'INE483C01032': 'TANLA',
  'INE483S01020': 'CCAVENUE',
  'INE484C01030': 'VEEDOL',
  'INE484I01029': 'PRECAM',
  'INE484J01027': 'GODREJPROP',
  'INE485A01015': 'CENTENKA',
  'INE485C01029': 'IOLCP',
  'INE486A01021': 'CESC',
  'INE486R01017': 'GPTHEALTH',
  'INE486Y01013': 'TOUCHWOOD',
  'INE488A01050': 'CHEMPLASTS',
  'INE488B01017': 'TASTYBITE',
  'INE488D01021': 'AVTNPL',
  'INE488V01015': 'PSPPROJECT',
  'INE489D01011': 'BNALTD',
  'INE489G01022': 'ANUHPHR',
  'INE489L01022': 'IIFLCAPS',
  'INE490G01020': 'MOIL',
  'INE491A01021': 'CUB',
  'INE491J01022': 'ASKAUTOLTD',
  'INE491V01019': 'CROWN',
  'INE492A01029': 'SUDARCOLOR',
  'INE494B01023': 'TVSMOTOR',
  'INE495A01022': 'DALMIASUG',
  'INE495B01038': 'SUVEN',
  'INE495C01010': 'SANGAMIND',
  'INE495P01020': 'BECTORFOOD',
  'INE495S01016': 'HPL',
  'INE497B01018': 'SEAMECLTD',
  'INE497D01022': 'DAMODARIND',
  'INE497S01012': 'GODAVARIB',
  'INE498A01018': 'DCM',
  'INE498B01024': 'SHOPERSTOP',
  'INE498E01010': 'SALONA',
  'INE498L01015': 'LTF',
  'INE498Q01014': 'VINCOFE',
  'INE499A01024': 'DCMSHRIRAM',
  'INE500A01029': 'DCW',
  'INE500L01026': 'SHK',
  'INE500X01013': 'LEXUS',
  'INE501A01019': 'DEEPAKFERT',
  'INE501G01024': 'HTMEDIA',
  'INE501X01029': 'AYE',
  'INE501Y01019': 'SCPL',
  'INE503A01015': 'DCBBANK',
  'INE503B01021': 'STEELXIND',
  'INE505A01010': 'DMCC',
  'INE505C01016': 'PRAENG',
  'INE505V01016': 'EUROBOND',
  'INE505Y01010': 'VINEETLAB',
  'INE506A01018': 'DREDGECORP',
  'INE506D01020': 'HALDYNGL',
  'INE506V01022': 'RUBICON',
  'INE506W01020': 'KRISHANA',
  'INE506Z01015': 'DHRUV',
  'INE507F01023': 'EMPOWER',
  'INE508G01029': 'TIMETECHNO',
  'INE508K01013': 'RHL',
  'INE509F01029': 'CUPID',
  'INE510A01028': 'ENGINERSIN',
  'INE510W01014': 'INOXGREEN',
  'INE511C01022': 'POONAWALLA',
  'INE511Y01018': 'MMP',
  'INE512B01022': 'FCSSOFT',
  'INE513A01022': 'SCHAEFFLER',
  'INE514Y01020': 'MOKSH',
  'INE515A01019': 'COCKERILL',
  'INE515C01023': 'LAHOTIOV',
  'INE516A01017': 'UFLEX',
  'INE517B01013': 'TTML',
  'INE517F01014': 'GPPL',
  'INE518E01015': 'ZIMLAB',
  'INE519A01011': 'FOSECOIND',
  'INE519C01017': 'SUMMITSEC',
  'INE520A01027': 'ZENSARTECH',
  'INE520H01022': 'BEARDSELL',
  'INE520Y01019': 'ICEMAKE',
  'INE521J01018': 'CPCAP',
  'INE522D01027': 'MANAPPURAM',
  'INE522F01014': 'COALINDIA',
  'INE523B01011': 'AKSHOPTFBR',
  'INE524A01029': 'GABRIEL',
  'INE524B01027': 'GANDHITUBE',
  'INE524L01026': 'KRIDHANINF',
  'INE524T01011': 'TAALTECH',
  'INE525F01025': 'BLIL',
  'INE526B01014': 'CALSOFT',
  'INE526E01018': 'SHRIPISTON',
  'INE526G01021': 'VIVIMEDLAB',
  'INE527H01019': 'UFO',
  'INE528A01020': 'GKWLIMITED',
  'INE528G01035': 'YESBANK',
  'INE529A01010': 'FMGOETZE',
  'INE529D01014': 'PATINTLOG',
  'INE529F01035': 'SIGIND',
  'INE529I01021': 'KUANTUM',
  'INE530B01024': 'IIFL',
  'INE531A01024': 'KANSAINER',
  'INE531E01026': 'HINDCOPPER',
  'INE531F01023': 'NUVAMA',
  'INE532F01054': 'EDELWEISS',
  'INE533A01012': 'GOODYEAR',
  'INE533D01032': 'RAJRILTD',
  'INE535D01037': 'ROTO',
  'INE535F01024': 'RAJOOENG',
  'INE536A01023': 'GRINDWELL',
  'INE536H01010': 'CIEINDIA',
  'INE537F01012': 'MODINATUR',
  'INE538A01037': 'GFLLIMITED',
  'INE539A01019': 'GHCL',
  'INE539B01017': 'VIRINCHI',
  'INE540A01017': 'GLFL',
  'INE540G01014': 'AMBIKCO',
  'INE540H01012': 'VOLTAMP',
  'INE540L01014': 'ALKEM',
  'INE541A01023': 'GMMPFAUDLR',
  'INE542B01011': 'AKSHARCHEM',
  'INE542C01019': 'NKIND',
  'INE542F01020': 'SWANDEF',
  'INE542W01025': 'KPIGREEN',
  'INE542Z01028': 'KAPSTON',
  'INE543V01017': 'ACEINTEG',
  'INE544A01019': 'HARRMALAYA',
  'INE544H01014': 'JHS',
  'INE544R01021': 'GREENLAM',
  'INE545A01024': 'HEG',
  'INE545H01011': 'TIIL',
  'INE545L01039': 'MANCREDIT',
  'INE545U01014': 'BANDHANBNK',
  'INE546C01010': 'PICCADIL',
  'INE546V01010': 'EIFFL',
  'INE546Y01022': 'PRAXIS',
  'INE547B01028': 'XTGLOBAL',
  'INE547E01014': 'IMPAL',
  'INE548A01028': 'HFCL',
  'INE548C01032': 'EMAMILTD',
  'INE548Z01017': 'LAGNAM',
  'INE549A01026': 'HCC',
  'INE549H01021': 'ARSSBL',
  'INE550B01022': 'HBSL',
  'INE550C01020': 'URJA',
  'INE550H01011': 'SUPREMEINF',
  'INE551D01018': 'PAKKA',
  'INE551W01018': 'UJJIVANSFB',
  'INE552D01024': 'CONFIPET',
  'INE552U01010': 'KPL',
  'INE552Z01027': 'ABDL',
  'INE553C01016': 'NECCLTD',
  'INE555B01013': 'AXISCADES',
  'INE555P01013': 'KIRANVYPAR',
  'INE555Z01020': 'TARACHAND',
  'INE557A01011': 'BIRLANU',
  'INE557B01019': 'LIBERTSHOE',
  'INE557Z01018': 'PIGL',
  'INE558D01021': 'CORALFINAC',
  'INE558R01013': 'HECPROJECT',
  'INE559A01017': 'IFBIND',
  'INE559D01011': 'CREST',
  'INE559N01010': 'SRGHFL',
  'INE559R01029': 'LANDMARK',
  'INE560A01023': 'INDIAGLYCO',
  'INE560K01014': 'PFS',
  'INE561C01019': 'BHARATGEAR',
  'INE561H01026': 'PARSVNATH',
  'INE561M01018': 'ISHANCH',
  'INE562A01011': 'INDIANB',
  'INE562B01019': 'RAJSREESUG',
  'INE562X01013': 'UNIVASTU',
  'INE563J01010': 'ASTEC',
  'INE565A01014': 'IOB',
  'INE565L01011': 'ZEELEARN',
  'INE565V01010': 'VALIANTORG',
  'INE566K01011': 'ISFT',
  'INE567A01028': 'NIPPOBATRY',
  'INE568Z01015': 'URAVIDEF',
  'INE569C01020': 'ORIENTCER',
  'INE570A01022': 'IONEXCHANG',
  'INE570D01018': 'ARROWGREEN',
  'INE570L01029': 'SAILIFE',
  'INE571A01038': 'IPCALAB',
  'INE571B01036': 'JAYBARMARU',
  'INE572A01036': 'JBCHEPHARM',
  'INE572D01014': 'FRONTSP',
  'INE572E01012': 'PNBHOUSING',
  'INE572G01025': 'LANCORHOL',
  'INE572J01011': 'SPANDANA',
  'INE573A01042': 'JKTYRE',
  'INE573K01025': 'RUSHIL',
  'INE573R01012': 'SEYAIND',
  'INE575C01027': 'INTLCONV',
  'INE575P01011': 'STARHEALTH',
  'INE576I01022': 'JKIL',
  'INE576O01020': 'LXCHEM',
  'INE577A01027': 'MUNJALSHOW',
  'INE577L01016': 'STEL',
  'INE578A01017': 'HEIDELBERG',
  'INE579B01039': 'ELPROINTL',
  'INE579C01029': 'VIMTALABS',
  'INE581X01021': 'GLOBE',
  'INE583B01015': 'SANDESH',
  'INE583C01021': 'DECCANCE',
  'INE583D01011': 'UGROCAP',
  'INE583R01029': 'PRITIKAUTO',
  'INE583V01021': 'RADHIKAJWE',
  'INE584A01023': 'NMDC',
  'INE584F01014': 'MANGALAM',
  'INE585B01010': 'MARUTI',
  'INE586B01026': 'TAJGVK',
  'INE586E01020': 'IWP',
  'INE586G01017': 'GULFPETRO',
  'INE586V01016': 'TCIEXP',
  'INE586X01012': 'GTECJAINX',
  'INE587G01015': 'KAYA',
  'INE589A01014': 'NLCINDIA',
  'INE590L01019': 'VASWANI',
  'INE591A01010': 'OILCOUNTUB',
  'INE591D01014': 'DIAMINESQ',
  'INE591G01025': 'COFORGE',
  'INE592A01026': 'ORIENTPPR',
  'INE592B01024': 'TTL',
  'INE593W01028': 'FOCUS',
  'INE594B01012': 'BSL',
  'INE594H01019': 'THYROCARE',
  'INE596F01018': 'PTCIL',
  'INE596H01014': 'HGM',
  'INE596I01020': 'CAMS',
  'INE597I01028': 'SHARDAMOTR',
  'INE597J01018': 'SHALBY',
  'INE597L01014': 'LOVABLE',
  'INE598C01011': 'HISARMETAL',
  'INE598D01035': 'ALGOQUANT',
  'INE599M01018': 'JUSTDIAL',
  'INE600A01035': 'PILITA',
  'INE600K01018': 'GALAXYSURF',
  'INE600L01024': 'LALPATHLAB',
  'INE600Y01019': 'DYCL',
  'INE602A01031': 'PCBL',
  'INE602G01020': 'KITEX',
  'INE602W01027': 'SENCO',
  'INE603A01013': 'PRAKASH',
  'INE603J01030': 'PIIND',
  'INE605D01012': 'NEAGI',
  'INE606A01024': 'AMJLAND',
  'INE606N01019': 'EXCELSOFT',
  'INE607A01022': 'PRIMO',
  'INE607D01018': 'ORIENTBELL',
  'INE608A01012': 'PSB',
  'INE609C01024': 'ORIENTLTD',
  'INE610B01024': 'GUJRAFFIA',
  'INE610C01014': 'ARENTERP',
  'INE610E01010': 'KALYANI',
  'INE611A01016': 'RSWM',
  'INE611L01021': 'INDTERRAIN',
  'INE612J01015': 'REPCOHOME',
  'INE613A01020': 'RALLIS',
  'INE613B01010': 'ICDSLTD',
  'INE613C01026': 'MCLOUD',
  'INE614A01028': 'RAMCOIND',
  'INE614B01018': 'KTKBANK',
  'INE614G01033': 'RPOWER',
  'INE615H01020': 'TITAGARH',
  'INE615I01010': 'GLOBUSSPR',
  'INE615P01015': 'QUESS',
  'INE615R01029': 'TRU',
  'INE616F01022': 'RSDFIN',
  'INE616N01034': 'INOXINDIA',
  'INE616Z01012': 'YASHO',
  'INE617A01013': 'SEMAC',
  'INE618L01018': '5PAISA',
  'INE618N01022': 'BALAXI',
  'INE618R01015': 'SGFIN',
  'INE619A01035': 'PATANJALI',
  'INE619B01017': 'NEWGEN',
  'INE619I01012': 'A2ZINFRA',
  'INE620D01011': 'INDPRUD',
  'INE621H01010': 'RELIGARE',
  'INE621L01012': 'TEXRAIL',
  'INE622H01018': 'INDOFARM',
  'INE622W01025': 'ACMESOLAR',
  'INE623A01011': 'SAKHTISUG',
  'INE623B01027': 'FEL',
  'INE624Z01016': 'SOLARA',
  'INE625B01014': 'RANASUG',
  'INE625G01013': 'WELENT',
  'INE625X01026': 'SILVERTUC',
  'INE626A01014': 'SAURASHCEM',
  'INE626Z01029': 'HARDWYN',
  'INE627H01017': 'CTE',
  'INE628A01036': 'UPL',
  'INE629D01020': 'BANSWRAS',
  'INE630A01024': 'SESHAPAPER',
  'INE630Y01024': 'MEDICO',
  'INE631A01022': 'SHANTIGEAR',
  'INE631R01026': 'MADHAVIPL',
  'INE632C01026': 'VIDHIING',
  'INE632X01030': 'SHRENIK',
  'INE633B01018': 'POLYPLEX',
  'INE634A01018': 'HONDAPOWER',
  'INE634I01029': 'KNRCON',
  'INE634S01028': 'MANKIND',
  'INE635A01023': 'SHYAMTEL',
  'INE635Q01029': 'GULFOILLUB',
  'INE636A01039': 'MAWANASUG',
  'INE637C01025': 'POKARNA',
  'INE637H01024': 'SHIVAMAUTO',
  'INE638A01035': 'SINGERIND',
  'INE640A01023': 'SKFINDIA',
  'INE640B01021': 'HBESD',
  'INE640C01011': 'SHAHALLOYS',
  'INE641C01019': 'KAVDEFENCE',
  'INE641R01017': 'QUINT',
  'INE642C01025': 'RUBFILA',
  'INE642Y01029': 'HINDCON',
  'INE642Z01026': 'AKI',
  'INE643A01035': 'JTEKTINDIA',
  'INE643K01018': 'ARIHANTSUP',
  'INE644Y01017': 'SHIVAMILLS',
  'INE645H01027': 'SUTLEJTEX',
  'INE645S01024': 'ROLEXRINGS',
  'INE645W01026': 'AIRAN',
  'INE646B01010': 'MEDICAMEQ',
  'INE646C01018': 'GROBTEA',
  'INE646H01017': 'CAPITALSFB',
  'INE646L01027': 'INDIGO',
  'INE646X01014': 'ASTRON',
  'INE647A01010': 'SRF',
  'INE647O01011': 'ABFRL',
  'INE647U01026': 'CLEANMAX',
  'INE648Z01023': 'ACCURACY',
  'INE650G01029': 'MENNPIS',
  'INE650K01021': 'SECURKLOUD',
  'INE650L01011': 'BROOKS',
  'INE651C01018': 'LAKPRE',
  'INE652F01027': 'CCHHL',
  'INE652V01016': 'GANESHCP',
  'INE652Z01025': 'AVROIND',
  'INE655A01013': 'STCINDIA',
  'INE655B01011': 'BANARBEADS',
  'INE655V01019': 'RMC',
  'INE657B01025': 'BLUECHIP',
  'INE658G01014': 'SALSTEEL',
  'INE658T01017': 'WEALTH',
  'INE659A01023': 'SUDARSCHEM',
  'INE660A01013': 'SUNDARMFIN',
  'INE660C01027': 'CENTRUM',
  'INE661I01014': 'BGRENERGY',
  'INE662A01027': 'SUPERSPIN',
  'INE663A01033': 'SPLPETRO',
  'INE663B01015': 'CONTROLPR',
  'INE663F01032': 'NAUKRI',
  'INE665A01038': 'SWANCORP',
  'INE665J01013': 'VMART',
  'INE665L01035': 'VARROC',
  'INE666D01022': 'BORORENEW',
  'INE666E01020': 'ACL',
  'INE667G01023': 'SAKSOFT',
  'INE668A01016': 'TMB',
  'INE668D01028': 'DONEAR',
  'INE668F01031': 'JYOTHYLAB',
  'INE668G01021': 'ELDEHSG',
  'INE669A01022': 'INFOMEDIA',
  'INE669C01036': 'TECHM',
  'INE669E01016': 'IDEA',
  'INE669R01026': 'ELITECON',
  'INE669X01032': 'GEEKAYWIRE',
  'INE670A01012': 'TATAELXSI',
  'INE670K01029': 'LODHA',
  'INE670X01014': 'LASA',
  'INE671A01010': 'HONAUT',
  'INE671H01015': 'SOBHA',
  'INE672A01026': 'TATAINVEST',
  'INE672B01032': 'MUNJALAU',
  'INE673O01025': 'TBOTEK',
  'INE674K01013': 'ABCAPITAL',
  'INE676A01027': 'BBOX',
  'INE677D01037': 'MASTERTR',
  'INE679A01013': 'CSBBANK',
  'INE679V01027': 'AVL',
  'INE680A01011': 'DHANBANK',
  'INE680Z01018': 'AVG',
  'INE681B01017': 'INDRAMEDCO',
  'INE681C01015': 'KEYFINSERV',
  'INE682M01012': 'JLHL',
  'INE683A01023': 'SOUTHBANK',
  'INE683C01011': 'MAITHANALL',
  'INE684F01012': 'FSL',
  'INE685A01028': 'TORNTPHARM',
  'INE686A01026': 'CEMPRO',
  'INE686F01025': 'UBL',
  'INE686Y01026': 'FINEORG',
  'INE687A01016': 'TRANSPEK',
  'INE688A01022': 'TCI',
  'INE688D01026': 'RESPONIND',
  'INE688J01023': 'LANDSMILL',
  'INE688Y01022': 'DANGEE',
  'INE689O01013': 'MERCANTILE',
  'INE689W01016': 'PRINCEPIPE',
  'INE690A01028': 'TTKPRESTIG',
  'INE691A01018': 'UCOBANK',
  'INE691Z01023': 'GANGAFORGE',
  'INE691Z20015': 'GANGAFO-RE',
  'INE692A01016': 'UNIONBANK',
  'INE692B01014': 'MURUDCERA',
  'INE692G01013': 'XCHANGING',
  'INE692Z01013': 'AFFORDABLE',
  'INE694A01020': 'UNITECH',
  'INE694D01016': 'VADILALIND',
  'INE694E01014': 'KANPRPLA',
  'INE694L01019': 'VEDPOWER',
  'INE694N01015': 'HERANBA',
  'INE695B01025': 'COUNCODOS',
  'INE696F01016': 'JUNIPER',
  'INE696K01024': 'PRAKASHSTL',
  'INE696V01013': 'JAIPURKURT',
  'INE697V01011': 'PANSARI',
  'INE699B01027': 'SAMBHAAV',
  'INE699H01024': 'AWL',
  'INE700A01033': 'JUBLPHARMA',
  'INE701A01023': 'VHL',
  'INE701G01012': 'AKCAPIT',
  'INE702C01027': 'APLAPOLLO',
  'INE703B01027': 'RATNAMANI',
  'INE703H01016': 'HUBTOWN',
  'INE704B01017': 'RACLGEAR',
  'INE704G01024': 'BAJAJST',
  'INE704H01022': 'CINELINE',
  'INE704J01044': 'VOGL',
  'INE704P01025': 'COCHINSHIP',
  'INE705C01020': 'SHIVATEX',
  'INE705X01026': 'GOYALALUM',
  'INE707A01012': 'VINDHYATEL',
  'INE707C01018': 'CAPTRUST',
  'INE709A01018': 'VLSFINANCE',
  'INE710A01016': 'VSTIND',
  'INE711A01022': 'WALCHANNAG',
  'INE712B01010': 'SUPERHOUSE',
  'INE712K01011': 'SHREEPUSHK',
  'INE713B01026': 'SURYALAXMI',
  'INE713C01016': 'SURAJLTD',
  'INE713R01022': 'GSPCROP',
  'INE713T01028': 'APOLLO',
  'INE715A01015': 'WHEELS',
  'INE715B01021': 'ANDHRSUGAR',
  'INE715Y01031': 'SHRADHA',
  'INE716A01013': 'WHIRLPOOL',
  'INE716B01029': 'TIPSMUSIC',
  'INE717A01029': 'KENNAMET',
  'INE717W01049': 'GANDHAR',
  'INE718F01018': 'CSLFINANCE',
  'INE718H01014': 'AUTOIND',
  'INE718I01012': 'JSWCEMENT',
  'INE719F01016': 'SHIVAUM',
  'INE720A01015': 'KOTHARIPET',
  'INE721A01047': 'SHRIRAMFIN',
  'INE721Z01010': 'AARON',
  'INE722B01019': 'PRAVEG',
  'INE722H01024': 'RGL',
  'INE722J01012': 'RKDL',
  'INE724A01017': 'GYFTR',
  'INE725A01030': 'NAVA',
  'INE725E01024': 'ORISSAMINE',
  'INE725G01011': 'ICRA',
  'INE725L01011': 'KARMAENG',
  'INE726G01019': 'ICICIPRULI',
  'INE726L01027': 'DELPHIFX',
  'INE726V01018': 'PRICOLLTD',
  'INE727B01026': 'GENESYS',
  'INE727S01012': 'BRNL',
  'INE728Z01015': 'SOFTTECH',
  'INE729D01010': 'KILITCH',
  'INE730A01022': 'ORICONENT',
  'INE731A01020': 'ARCHIES',
  'INE731C01018': 'KHAITANLTD',
  'INE731F01037': 'WELSPLSOL',
  'INE731H01025': 'ACE',
  'INE731U01028': 'DIGJAMLMTD',
  'INE732A01036': 'KIRLOSBROS',
  'INE732C01016': 'NCLIND',
  'INE732I01021': 'ANGELONE',
  'INE732S01012': 'SAKAR',
  'INE733A01018': 'STARPAPER',
  'INE733E01010': 'NTPC',
  'INE734I01027': 'FINKURVE',
  'INE734N01019': 'SNOWMAN',
  'INE735M01018': 'SAMPANN',
  'INE735W01017': 'UTKARSHBNK',
  'INE736A01011': 'CDSL',
  'INE737B01033': 'ADROITINFO',
  'INE737D01021': 'MODISONLTD',
  'INE737H01014': 'FIEMIND',
  'INE737W01013': 'AKASH',
  'INE738I01010': 'ECLERX',
  'INE738V01013': 'ARTNIRMAN',
  'INE739E01017': 'CERA',
  'INE740D01017': 'NRAIL',
  'INE740V01019': 'AGROPHOS',
  'INE740X01023': 'LAL',
  'INE741K01010': 'CREDITACC',
  'INE741L01018': 'DUCON',
  'INE742B01025': 'GUFICBIO',
  'INE742C01031': 'JINDRILL',
  'INE742F01042': 'ADANIPORTS',
  'INE743M01012': 'RHIM',
  'INE745B01028': 'KHAICHEM',
  'INE745G01043': 'MCX',
  'INE746D01014': 'PIONRINV',
  'INE747B01016': 'NEXTMEDIA',
  'INE747K01017': 'TARAPUR',
  'INE748C01038': '3IINFOLTD',
  'INE748T01016': 'SIMBHALS',
  'INE748Z01013': 'SUMIT',
  'INE749A01030': 'JINDALSTEL',
  'INE749B01020': 'ORTINGLOBE',
  'INE750A01020': 'ORIENTHOT',
  'INE750C01026': 'MARKSANS',
  'INE750D01016': 'RELCHEMQ',
  'INE750M01017': 'HEXATRADEX',
  'INE750R01016': 'AARNAV',
  'INE751B01018': 'PIXTRANS',
  'INE752E01010': 'POWERGRID',
  'INE752G01015': 'MSPL',
  'INE752H01013': 'CARERATING',
  'INE753K01015': 'EMMBI',
  'INE753U01022': 'DIVGIITTS',
  'INE753W01010': 'SANGINITA',
  'INE754A01055': 'SUBEXLTD',
  'INE754X01016': 'AARVI',
  'INE756C01015': 'NDGL',
  'INE756I01012': 'HDBFS',
  'INE757A01017': 'COSMOFIRST',
  'INE757B01015': 'TRANSWORLD',
  'INE757T01025': 'AEPL',
  'INE758C01029': 'AHLUCONT',
  'INE758E01017': 'JIOFIN',
  'INE758T01015': 'ETERNAL',
  'INE759A01021': 'MASTEK',
  'INE759V01019': 'HEADSUP',
  'INE760A01029': 'KOKUYOCMLN',
  'INE760F01028': 'INDOAMIN',
  'INE760L01018': 'TBZ',
  'INE760W01023': 'RPPL',
  'INE760Y01011': 'ASHOKAMET',
  'INE761G01016': 'BLACKROSE',
  'INE761H01022': 'PAGEIND',
  'INE761Y01019': 'ZODIAC',
  'INE763I01026': 'TARIL',
  'INE763M01028': 'MERCURYEV',
  'INE764D01017': 'VSTTILLERS',
  'INE764L01010': 'SADBHIN',
  'INE765D01022': 'WPIL',
  'INE765G01017': 'ICICIGI',
  'INE766P01016': 'MAHLOG',
  'INE767A01016': 'AARTIDRUGS',
  'INE768C01028': 'ZYDUSWELL',
  'INE769A01020': 'AARTIIND',
  'INE770A01010': 'PRADPME',
  'INE771A01026': 'MIRZAINT',
  'INE771F01041': 'FISCHER',
  'INE772T01024': 'PVSL',
  'INE773I01017': 'ALKALI',
  'INE774D01024': 'M&MFIN',
  'INE775A01035': 'MOTHERSON',
  'INE776C01039': 'GMRAIRPORT',
  'INE776I01010': 'MEP',
  'INE777F01014': 'EXICOM',
  'INE777K01022': 'RRKABEL',
  'INE778B01029': 'ESTER',
  'INE778K01012': 'EMAMIREAL',
  'INE780C01023': 'JMFINANCIL',
  'INE781A01025': 'INTENTECH',
  'INE781B01015': 'NOIDATOLL',
  'INE781S01027': 'VENTIVE',
  'INE782A01015': 'BOSCH-HCIL',
  'INE782E01017': 'HESTERBIO',
  'INE782X01033': 'SERVOTECH',
  'INE783X01023': 'CHEMFAB',
  'INE784B01035': 'WINSOME',
  'INE784R01023': 'ARFIN',
  'INE784W01015': 'MANOMAY',
  'INE785A01026': 'JAYAGROGN',
  'INE785M01021': 'PCJEWELLER',
  'INE786A01032': 'JKLAKSHMI',
  'INE786F01031': 'UTTAMSUGAR',
  'INE786W01010': 'RKEC',
  'INE787D01026': 'BALKRISIND',
  'INE788H01017': 'HILTON',
  'INE788J01021': 'SHIVALIK',
  'INE789E01012': 'JKPAPER',
  'INE790B01024': 'KCPSUGIND',
  'INE790G01031': 'SHILPAMED',
  'INE791A01024': 'BLBLIMITED',
  'INE791I01019': 'BRIGADE',
  'INE792B01012': 'AMBICAAGAR',
  'INE792H01019': 'GLOBALVECT',
  'INE792I01017': 'CORDSCABLE',
  'INE792Z01011': 'SIRCA',
  'INE793A01012': 'ACCELYA',
  'INE794A01010': 'NEULANDLAB',
  'INE794B01026': 'BALAJITELE',
  'INE794W01014': 'MODTHREAD',
  'INE795G01014': 'HDFCLIFE',
  'INE796G01012': 'JINDALPHOT',
  'INE797F01020': 'JUBLFOOD',
  'INE797H01018': 'TGBHOTELS',
  'INE798K01010': 'KRITINUT',
  'INE800A01015': 'BIRLACABLE',
  'INE800H01010': 'OMAXE',
  'INE801L01010': 'AIROLAM',
  'INE801V01019': 'LAXMICOT',
  'INE802B01027': 'LINC',
  'INE802C01033': 'SSWL',
  'INE802W01023': 'BOHRAIND',
  'INE803D01021': 'INDOBORAX',
  'INE803H01014': 'RUCHIRA',
  'INE804H01012': 'TFL',
  'INE804L01022': 'MEDPLUS',
  'INE805A01014': 'GOLDTECH',
  'INE805C01028': 'KCP',
  'INE805D01034': 'SUNTECK',
  'INE806A01020': 'VIKASECO',
  'INE806C01018': 'TIL',
  'INE806T01020': 'SAPPHIRE',
  'INE807F01027': 'VIYASH',
  'INE807K01035': 'SCHAND',
  'INE809A01032': 'RAMAPHO',
  'INE809I01019': 'ONMOBILE',
  'INE810G01011': 'SHYAMMETL',
  'INE811A01020': 'KIRLPNU',
  'INE811K01011': 'PRESTIGE',
  'INE812G01025': 'SMSPHARMA',
  'INE813A01018': 'MAHLIFE',
  'INE813H01021': 'TORNTPOWER',
  'INE813V01022': 'MCL',
  'INE814H01029': 'ADANIPOWER',
  'INE816B01035': 'FILATEX',
  'INE818A01017': 'ANTELOPUS',
  'INE818B01023': 'PASUPTAC',
  'INE818H01020': 'LTFOODS',
  'INE818W01011': 'ESAFSFB',
  'INE819A01049': 'COMFINTE',
  'INE819L01012': 'ELGIRUBCO',
  'INE819V01029': 'CPPLUS',
  'INE820Y01021': 'AJOONI',
  'INE821I01022': 'IRB',
  'INE822C01015': 'TCPLPACK',
  'INE822E01011': 'SUPREME',
  'INE822G01016': 'ELECTHERM',
  'INE823A01017': 'KOTHARIPRO',
  'INE823G01014': 'JKCEMENT',
  'INE824G01012': 'JSWHL',
  'INE824Q01011': 'MANAKSTEEL',
  'INE825A01020': 'VTL',
  'INE825V01034': 'MANYAVAR',
  'INE826C01016': 'GUJAPOLLO',
  'INE828A01016': 'BIL',
  'INE828O01033': 'MITCON',
  'INE829A01014': 'BIOFILCHEM',
  'INE830C01026': 'EMAMIPAP',
  'INE830Q01018': 'MANAKCOAT',
  'INE831A01028': 'ONIDA',
  'INE832A01018': 'MODIRUBBER',
  'INE834I01025': 'KHADIM',
  'INE834M01019': 'RTNINDIA',
  'INE835A01029': 'VARDMNPOLY',
  'INE835B01035': 'MOLDTECH',
  'INE835D01023': 'HIRECT',
  'INE835G01018': 'ALLDIGI',
  'INE836A01035': 'BSOFT',
  'INE836B01017': 'SATIN',
  'INE836F01026': 'DISHTV',
  'INE837H01020': 'ADVENZYMES',
  'INE838B01021': 'BHARATRAS',
  'INE838E01017': 'PONNIERODE',
  'INE839G01010': 'JOCIL',
  'INE839M01018': 'SCHNEIDER',
  'INE840M01016': 'ZUARI',
  'INE840Y01029': 'ONEPOINT',
  'INE841B01017': 'INDBANK',
  'INE841L01016': 'DEEDEV',
  'INE842C01021': 'MINDACORP',
  'INE843B01013': 'MAHAPEXLTD',
  'INE843D01027': 'DCMSRIND',
  'INE843S01025': 'SURAJEST',
  'INE844A01013': 'PEARLPOLY',
  'INE844K01012': 'BEDMUTHA',
  'INE844O01030': 'GUJENERGY',
  'INE845D01014': 'GANECOS',
  'INE846D01012': 'LORDSCHLO',
  'INE847C01020': 'ROSSELLIND',
  'INE848A01014': 'IZMO',
  'INE848E01016': 'NHPC',
  'INE849A01020': 'TRENT',
  'INE849C01026': 'SHALPAINTS',
  'INE849L01019': 'ORTEL',
  'INE850B01026': 'ABMKNO',
  'INE850D01014': 'GODREJAGRO',
  'INE850E01012': 'LFIC',
  'INE850M01015': 'NORTHARC',
  'INE851I01011': 'UDS',
  'INE852O01025': 'APTUS',
  'INE854B01010': 'JAYNECOIND',
  'INE854D01024': 'UNITDSPR',
  'INE854S01022': 'GENCON',
  'INE855B01025': 'RAIN',
  'INE855C01023': 'WEBELSOLAR',
  'INE855F01042': 'ASMS',
  'INE855R01021': 'RADIANTCMS',
  'INE858B01029': 'ISGEC',
  'INE858F01012': 'NITCO',
  'INE859A01011': 'PNBGILTS',
  'INE859Q01017': 'MANAKALUCO',
  'INE860A01027': 'HCLTECH',
  'INE860T01019': 'SABEVENTS',
  'INE861B01023': 'MOTOGENFIN',
  'INE861D01011': 'SAHLIBHFI',
  'INE862Y01015': 'BANKA',
  'INE863B01029': 'PREMEXPLN',
  'INE863I01016': 'BANG',
  'INE863T01013': 'JITFINFRA',
  'INE864I01014': 'MTARTECH',
  'INE864J01012': 'TAMBOLIIN',
  'INE864K01010': 'IRIS',
  'INE864X01013': 'DPWIRES',
  'INE865C01022': 'BIRLAMONEY',
  'INE865T01018': 'PDMJEPAPER',
  'INE866K01023': 'WAAREEINDO',
  'INE866R01028': 'MATRIMONY',
  'INE867A01022': 'MANUGRAPH',
  'INE868B01028': 'NCC',
  'INE869I01013': 'GTPL',
  'INE869Y01010': 'TEMBO',
  'INE870D01012': 'NFL',
  'INE870H01013': 'NETWORK18',
  'INE871C01038': 'AVANTIFEED',
  'INE871H01011': 'GSS',
  'INE871K01015': 'HMVL',
  'INE871L01013': 'TVVISION',
  'INE872H01027': 'LUMAXTECH',
  'INE872J01023': 'DEVYANI',
  'INE873D01024': 'INDOCO',
  'INE874F01027': 'RADAAN',
  'INE874I01013': 'RAMKY',
  'INE875B01015': 'NIMBSPROJ',
  'INE875G01048': 'NDL',
  'INE875R01011': 'BALKRISHNA',
  'INE876N01018': 'ORIENTCEM',
  'INE877F01012': 'PTC',
  'INE877I01016': 'ARCHIDPLY',
  'INE877V01027': 'SURAKSHA',
  'INE878A01011': 'GVPIL',
  'INE878B01027': 'KEI',
  'INE878E01021': 'SETCO',
  'INE878H01024': 'INVENTURE',
  'INE878I01022': 'BAFNAPH',
  'INE878K01010': 'BFINVEST',
  'INE879A01019': 'SHREERAMA',
  'INE879E01037': 'KANANIIND',
  'INE879I01012': 'DBREALTY',
  'INE880J01026': 'JSWINFRA',
  'INE880L01014': 'KIOCL',
  'INE880Y01017': 'SOLEX',
  'INE881D01027': 'OFSS',
  'INE882A01013': 'MARALOVER',
  'INE883A01011': 'MRF',
  'INE883F01010': 'AADHARHFC',
  'INE883N01014': 'PARAGMILK',
  'INE884A01027': 'VAIBHAVGBL',
  'INE884B01025': 'KIRLFER',
  'INE885A01032': 'ARE&M',
  'INE885E01042': 'MAZDA',
  'INE885F01015': 'MASKINVEST',
  'INE885H01029': 'SPORTKING',
  'INE886A01014': 'IITL',
  'INE886D01026': 'EFCIL',
  'INE887D01016': 'TCC',
  'INE887E01022': 'NGLFINE',
  'INE887G01027': 'GOKEX',
  'INE888C01040': 'SADHNANIQ',
  'INE890C01046': 'SANWARIA',
  'INE891B01012': 'DCMFINSERV',
  'INE891D01026': 'REDINGTON',
  'INE893I01013': 'VASCONEQ',
  'INE893J01029': 'MOLDTKPAC',
  'INE894V01022': 'BELRISE',
  'INE895B01021': 'RUPA',
  'INE895W01019': 'PANACHE',
  'INE896L01010': 'INDOSTAR',
  'INE898S01029': 'AURUM',
  'INE899L01030': 'UEL',
  'INE900B01029': 'KABRAEXTRU',
  'INE900C01027': 'ASAL',
  'INE900L01028': 'MBAPL',
  'INE901L01018': 'APLLTD',
  'INE902B01017': 'S&SPOWER',
  'INE903A01025': 'JAYKAY',
  'INE903D01011': 'MONARCH',
  'INE903U01023': 'SIGNATURE',
  'INE906O01029': 'TIGERLOGS',
  'INE907A01026': 'KSL',
  'INE908D01010': 'SHAKTIPUMP',
  'INE908V01012': 'LIBAS',
  'INE910A01012': 'NIRLON',
  'INE910C01018': 'TTKHLTCARE',
  'INE911B01018': 'TCIFINANCE',
  'INE912H01013': 'MBLINFRA',
  'INE912L01015': 'ONELIFECAP',
  'INE912T01018': 'RPEL',
  'INE913H01037': 'ENDURANCE',
  'INE914E01040': 'ALANKIT',
  'INE914M01019': 'ASTERDM',
  'INE915B01019': 'INDSWFTLAB',
  'INE915K01010': 'AHLWEST',
  'INE916G01016': 'GEECEE',
  'INE916U01025': 'SFL',
  'INE916Y01027': 'AFIL',
  'INE917H01012': 'SRHHYPOLTD',
  'INE917I01010': 'BAJAJ-AUTO',
  'INE917M01012': 'DBL',
  'INE918I01026': 'BAJAJFINSV',
  'INE918N01018': 'VETO',
  'INE918Z01012': 'KAYNES',
  'INE919H01018': 'IMFA',
  'INE919I01024': 'RADIOCITY',
  'INE920A01037': 'DOLPHIN',
  'INE921B01025': 'DBSTOCKBRO',
  'INE921L01032': 'POWERICA',
  'INE922A01025': 'BEPL',
  'INE922B01023': 'PANACEABIO',
  'INE922K01024': 'INDIASHLTR',
  'INE923A01015': 'SILINV',
  'INE924D01017': 'THEINVEST',
  'INE924H01018': 'TARMAT',
  'INE925C01016': 'MADHAV',
  'INE925R01014': 'CMSINFO',
  'INE926B01016': 'GRANDOAK',
  'INE926K01017': 'AHLEAST',
  'INE926X01010': 'HGINFRA',
  'INE927A01040': 'ROLLT',
  'INE927C01020': 'DIGISPICE',
  'INE927D01051': 'JBMA',
  'INE927X01018': 'ELCIDIN',
  'INE928C01010': 'DAICHI',
  'INE930H01031': 'KPRMILL',
  'INE930P01018': 'ANURAS',
  'INE931S01010': 'ADANIENSOL',
  'INE932A01024': 'PENIND',
  'INE932C01012': 'TOKYOPLAST',
  'INE932X01026': 'SHAREINDIA',
  'INE933A01014': 'LYKALABS',
  'INE933B01012': 'SIGMAADV',
  'INE933K01021': 'BAJAJCON',
  'INE933S01016': 'INDIAMART',
  'INE933X01016': 'SHANTI',
  'INE934C01018': 'DRAGARWQ',
  'INE934S01014': 'GNA',
  'INE935A01035': 'GLENMARK',
  'INE935B01025': 'MOSCHIP',
  'INE935N01020': 'DIXON',
  'INE936B01015': 'NATCAPSUQ',
  'INE937A01023': 'SPMLINFRA',
  'INE937C01029': 'NILAINFRA',
  'INE938A01021': 'LCCINFOTEC',
  'INE939A01011': 'STAR',
  'INE939X01013': 'MANBA',
  'INE940H01022': 'PGIL',
  'INE942C01045': 'GUJTHEM',
  'INE942G01012': 'MCLEODRUSS',
  'INE943D01017': 'MPSLTD',
  'INE943P01029': 'AGARWALEYE',
  'INE944F01028': 'RADICO',
  'INE945F01025': 'DECNGOLD',
  'INE945H01021': 'V2RETAIL',
  'INE946H01037': 'VIPULLTD',
  'INE947A01014': 'SUNFLAG',
  'INE947I01017': 'LOTUSEYE',
  'INE947J01015': 'DEN',
  'INE947N01017': 'AEQUS',
  'INE947Q01028': 'LAURUSLABS',
  'INE947T01022': 'GICL',
  'INE948A01012': 'TRIGYN',
  'INE949H01023': 'MANINFRA',
  'INE949L01017': 'AUBANK',
  'INE949P01018': 'GENUSPAPER',
  'INE950I01011': 'DBCORP',
  'INE950M01013': 'MONTECARLO',
  'INE951D01028': 'ATULAUTO',
  'INE951I01027': 'VGUARD',
  'INE951M01037': 'RRIL',
  'INE952H01027': 'RAJTV',
  'INE953L01027': 'JSFB',
  'INE953O01021': 'SANSERA',
  'INE953R01016': 'PNGJL',
  'INE954E01012': 'MOHITIND',
  'INE955D01029': 'GENUSPOWER',
  'INE955I01044': 'SEJALLTD',
  'INE955V01021': 'ARVINDFASN',
  'INE956G01038': 'WABAG',
  'INE956O01016': 'LENSKART',
  'INE959A01019': 'PRIVISCL',
  'INE959C01023': 'OAL',
  'INE961D01019': 'UNIDT',
  'INE961O01016': 'RAINBOW',
  'INE962C01035': 'EASTSILK',
  'INE962Y01021': 'IRCON',
  'INE963C01033': 'FAZE3Q',
  'INE964H01014': 'SEPC',
  'INE964W01021': 'MKPL',
  'INE965B01022': 'HYBRIDFIN',
  'INE965H01011': 'SITINET',
  'INE965W01036': 'BMWVENTLTD',
  'INE966A01022': 'DOLATALGO',
  'INE966H01019': 'ZEEMEDIA',
  'INE967C01018': 'KAMATHOTEL',
  'INE967G01019': 'ZSARACOM',
  'INE967H01025': 'KIMS',
  'INE968D01022': 'ARSHIYA',
  'INE970D01010': 'LOYALTEX',
  'INE970N01027': 'SPCENET',
  'INE970X01018': 'LEMONTREE',
  'INE972A01020': 'KOTIC',
  'INE972X01022': 'VAISHALI',
  'INE973A01010': 'GOLDENTOBC',
  'INE974B01016': 'CHEVIOT',
  'INE974X01010': 'TIINDIA',
  'INE974Z01015': 'PRITI',
  'INE975G01012': 'IL&FSTRANS',
  'INE976A01021': 'WSTCSTPAPR',
  'INE976E01023': 'FOODSIN',
  'INE976G01028': 'RBLBANK',
  'INE976I01016': 'TATACAP',
  'INE976R01033': 'AGIIL',
  'INE976T01013': 'SAGARDEEP',
  'INE977Y01011': 'BCONCEPTS',
  'INE978A01027': 'HERITGFOOD',
  'INE978G01016': 'SPLIL',
  'INE979A01025': 'SAREGAMA',
  'INE979B01015': 'HAWKINCOOK',
  'INE979R01011': 'SHYAMCENT',
  'INE980O01024': 'JYOTICNC',
  'INE980Y01015': 'SOUTHWEST',
  'INE982B01027': 'ADFFOODS',
  'INE982F01036': 'HATHWAY',
  'INE982J01020': 'PAYTM',
  'INE982V01025': 'JETFREIGHT',
  'INE985A01022': 'SINCLAIR',
  'INE985S01024': 'TEAMLEASE',
  'INE985W01018': 'CNL',
  'INE986A01012': 'BI',
  'INE987B01026': 'NATCOPHARM',
  'INE987S01020': 'KSHINTL',
  'INE988S01028': 'PARKHOTELS',
  'INE989A01032': 'SANGHVIMOV',
  'INE989C01038': 'DIACABS',
  'INE991I01015': 'ASPINWALL',
  'INE992I01013': 'STARTECK',
  'INE993A01026': 'MANINDS',
  'INE994E01018': '3BBLACKBIO',
  'INE995D01025': 'CHEMBOND',
  'INE995S01015': 'NIVABUPA',
  'INE997I01012': 'SHRIKRISH',
  'INE997Y01027': 'MITTAL',
  'INE998H01012': 'ORIENTALTL',
  'INE998I01010': 'MHRIL',
  'INE999A01023': 'KSB',
  'INE999K01014': 'GREENPOWER',
};